import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AbTesting = {
  __typename?: 'AbTesting';
  abTestType?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type AbTestingInput = {
  abTestType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AbandonDossierResult = {
  __typename?: 'AbandonDossierResult';
  abandonned: Scalars['Boolean']['output'];
  dossierForContractManager?: Maybe<Scalars['JSON']['output']>;
};

export type Ack = {
  __typename?: 'Ack';
  clientKey?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type AddressElements = {
  __typename?: 'AddressElements';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  streetSuffix?: Maybe<Scalars['String']['output']>;
};

export type AddressElementsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  streetSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaEvent = {
  __typename?: 'AgendaEvent';
  additionalData?: Maybe<Scalars['JSON']['output']>;
  allDay?: Maybe<Scalars['Boolean']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['Date']['output']>;
  creationData?: Maybe<AgendaEventCreationData>;
  endTime?: Maybe<Scalars['Date']['output']>;
  fitterId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interventionVehicle?: Maybe<AgendaEventFitterResource>;
  locations?: Maybe<Array<Scalars['String']['output']>>;
  recurrent?: Maybe<AgendaEventRecurrence>;
  resources?: Maybe<Array<Maybe<AgendaEventFitterResource>>>;
  startTime?: Maybe<Scalars['Date']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['Date']['output']>;
};

export type AgendaEventCreationData = {
  __typename?: 'AgendaEventCreationData';
  code?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
};

export type AgendaEventCreationDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaEventFitterResource = {
  __typename?: 'AgendaEventFitterResource';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AgendaEventFitterResourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaEventInput = {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  fitterId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interventionVehicle?: InputMaybe<AgendaEventFitterResourceInput>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  recurrent?: InputMaybe<AgendaEventRecurrenceInput>;
  resources?: InputMaybe<Array<InputMaybe<AgendaEventFitterResourceInput>>>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaEventRecurrence = {
  __typename?: 'AgendaEventRecurrence';
  daysDeletes?: Maybe<Array<AgendaRecurrencePeriodDelete>>;
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  endDate?: Maybe<Scalars['String']['output']>;
  every?: Maybe<Scalars['Int']['output']>;
  freq?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type AgendaEventRecurrenceInput = {
  daysDeletes?: InputMaybe<Array<AgendaRecurrencePeriodDeleteInput>>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  every?: InputMaybe<Scalars['Int']['input']>;
  freq?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaRecurrencePeriodDelete = {
  __typename?: 'AgendaRecurrencePeriodDelete';
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type AgendaRecurrencePeriodDeleteInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  assignedInterventionVehicle?: Maybe<Scalars['String']['output']>;
  assignedReplacementVehicle?: Maybe<FitterReplacementVehicle>;
  assignedReplacementVehicleUse?: Maybe<InUsePeriod>;
  assignedResources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  extraCost?: Maybe<Scalars['Float']['output']>;
  fitterId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  immobilisationDuration?: Maybe<Scalars['Int']['output']>;
  interventionDuration?: Maybe<Scalars['Int']['output']>;
  interventionId?: Maybe<Scalars['String']['output']>;
  interventionLocation?: Maybe<LocationDataGeocoded>;
  isConveying?: Maybe<Scalars['Boolean']['output']>;
  isInterventionDifficult?: Maybe<Scalars['Boolean']['output']>;
  isReplacementVehicleSelected?: Maybe<Scalars['Boolean']['output']>;
  isValidatedByFitter?: Maybe<Scalars['Boolean']['output']>;
  itinerary?: Maybe<Itinerary>;
  outsideIntervention?: Maybe<Scalars['Boolean']['output']>;
  partAvailability?: Maybe<Scalars['String']['output']>;
  partProvider?: Maybe<Scalars['String']['output']>;
  reminderIsSent?: Maybe<Scalars['Boolean']['output']>;
  replacementVehicle?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type AppointmentInput = {
  assignedInterventionVehicle?: InputMaybe<Scalars['String']['input']>;
  assignedReplacementVehicle?: InputMaybe<FitterReplacementVehicleInput>;
  assignedReplacementVehicleUse?: InputMaybe<InUsePeriodInput>;
  assignedResources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  extraCost?: InputMaybe<Scalars['Float']['input']>;
  fitterId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  immobilisationDuration?: InputMaybe<Scalars['Int']['input']>;
  interventionDuration?: InputMaybe<Scalars['Int']['input']>;
  interventionId?: InputMaybe<Scalars['String']['input']>;
  interventionLocation?: InputMaybe<LocationDataGeocodedInput>;
  isConveying?: InputMaybe<Scalars['Boolean']['input']>;
  isInterventionDifficult?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacementVehicleSelected?: InputMaybe<Scalars['Boolean']['input']>;
  isValidatedByFitter?: InputMaybe<Scalars['Boolean']['input']>;
  itinerary?: InputMaybe<ItineraryInput>;
  outsideIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  partAvailability?: InputMaybe<Scalars['String']['input']>;
  partProvider?: InputMaybe<Scalars['String']['input']>;
  reminderIsSent?: InputMaybe<Scalars['Boolean']['input']>;
  replacementVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalCost?: InputMaybe<Scalars['Float']['input']>;
};

export type Call = {
  __typename?: 'Call';
  callDuration?: Maybe<Scalars['Int']['output']>;
  callReason?: Maybe<Scalars['String']['output']>;
  callSid?: Maybe<Scalars['String']['output']>;
  conferenceName?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  phoneNumberFrom?: Maybe<Scalars['String']['output']>;
  phoneNumberTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userCallee?: Maybe<Scalars['String']['output']>;
  userCaller?: Maybe<Scalars['String']['output']>;
};

export type CallInput = {
  callDuration?: InputMaybe<Scalars['Int']['input']>;
  callReason?: InputMaybe<Scalars['String']['input']>;
  callSid?: InputMaybe<Scalars['String']['input']>;
  conferenceName?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['Date']['input']>;
  phoneNumberFrom?: InputMaybe<Scalars['String']['input']>;
  phoneNumberTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userCallee?: InputMaybe<Scalars['String']['input']>;
  userCaller?: InputMaybe<Scalars['String']['input']>;
};

export type Car = {
  __typename?: 'Car';
  characteristics?: Maybe<CarCharacteristics>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firstRegistration?: Maybe<Scalars['Date']['output']>;
  licensePlateNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  ownerShip?: Maybe<CarOwnerShipData>;
  parts?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  registrationCode?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  vinNumber?: Maybe<Scalars['String']['output']>;
};

export type CarCharacteristics = {
  __typename?: 'CarCharacteristics';
  chassisNumber?: Maybe<Scalars['String']['output']>;
  co2Emission?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cylinders?: Maybe<Scalars['Int']['output']>;
  energy?: Maybe<Scalars['String']['output']>;
  engineNumber?: Maybe<Scalars['String']['output']>;
  fiscalPower?: Maybe<Scalars['Int']['output']>;
  gearboxNbSpeed?: Maybe<Scalars['Int']['output']>;
  gearboxNumber?: Maybe<Scalars['String']['output']>;
  gearboxType?: Maybe<Scalars['String']['output']>;
  horsepower?: Maybe<Scalars['Int']['output']>;
  kwPower?: Maybe<Scalars['Int']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  numberOfDoors?: Maybe<Scalars['Int']['output']>;
  propulsionType?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<Scalars['String']['output']>;
  totalRollingWeight?: Maybe<Scalars['Int']['output']>;
  unloadedWeight?: Maybe<Scalars['Int']['output']>;
};

export type CarCharacteristicsInput = {
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  co2Emission?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  cylinders?: InputMaybe<Scalars['Int']['input']>;
  energy?: InputMaybe<Scalars['String']['input']>;
  engineNumber?: InputMaybe<Scalars['String']['input']>;
  fiscalPower?: InputMaybe<Scalars['Int']['input']>;
  gearboxNbSpeed?: InputMaybe<Scalars['Int']['input']>;
  gearboxNumber?: InputMaybe<Scalars['String']['input']>;
  gearboxType?: InputMaybe<Scalars['String']['input']>;
  horsepower?: InputMaybe<Scalars['Int']['input']>;
  kwPower?: InputMaybe<Scalars['Int']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  numberOfDoors?: InputMaybe<Scalars['Int']['input']>;
  propulsionType?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  registrationType?: InputMaybe<Scalars['String']['input']>;
  totalRollingWeight?: InputMaybe<Scalars['Int']['input']>;
  unloadedWeight?: InputMaybe<Scalars['Int']['input']>;
};

export type CarInput = {
  characteristics?: InputMaybe<CarCharacteristicsInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstRegistration?: InputMaybe<Scalars['Date']['input']>;
  licensePlateNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  ownerShip?: InputMaybe<CarOwnerShipDataInput>;
  parts?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  registrationCode?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  vinNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CarOwnerShipData = {
  __typename?: 'CarOwnerShipData';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CarOwnerShipDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Claim = {
  __typename?: 'Claim';
  calibration?: Maybe<Scalars['String']['output']>;
  car?: Maybe<Car>;
  constructorRef?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  eurocode?: Maybe<Scalars['String']['output']>;
  glass?: Maybe<SinisterGlass>;
  operationType?: Maybe<Scalars['String']['output']>;
  sinisterComment?: Maybe<Scalars['String']['output']>;
  sinisterContext?: Maybe<SinisterContext>;
  sinisterDate?: Maybe<Scalars['Date']['output']>;
  sinisterLocation?: Maybe<Scalars['String']['output']>;
  sinisterPlace?: Maybe<LocationDataGeocoded>;
};

export type ClaimInput = {
  calibration?: InputMaybe<Scalars['String']['input']>;
  car?: InputMaybe<CarInput>;
  constructorRef?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  eurocode?: InputMaybe<Scalars['String']['input']>;
  glass?: InputMaybe<SinisterGlassInput>;
  operationType?: InputMaybe<Scalars['String']['input']>;
  sinisterComment?: InputMaybe<Scalars['String']['input']>;
  sinisterContext?: InputMaybe<SinisterContextInput>;
  sinisterDate?: InputMaybe<Scalars['Date']['input']>;
  sinisterLocation?: InputMaybe<Scalars['String']['input']>;
  sinisterPlace?: InputMaybe<LocationDataGeocodedInput>;
};

export type CloseDossier = {
  __typename?: 'CloseDossier';
  dossierId?: Maybe<Scalars['String']['output']>;
};

export type CreationData = {
  __typename?: 'CreationData';
  businessOrigin?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
};

export type CurrentlyInUseInfos = {
  __typename?: 'CurrentlyInUseInfos';
  timestamp?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  billingLocation?: Maybe<LocationDataGeocoded>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationDataGeocoded>;
  notificationPreference?: Maybe<NotificationTypeEnum>;
  phoneNumber?: Maybe<PhoneNumber>;
};

export type CustomerInput = {
  billingLocation?: InputMaybe<LocationDataGeocodedInput>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationDataGeocodedInput>;
  notificationPreference?: InputMaybe<NotificationTypeEnumInput>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
};

export type DepartingDossier = {
  __typename?: 'DepartingDossier';
  dossierId?: Maybe<Scalars['String']['output']>;
  newFitterId?: Maybe<Scalars['String']['output']>;
  oldFitterId?: Maybe<Scalars['String']['output']>;
};

export type Document = {
  __typename?: 'Document';
  metadata?: Maybe<DocumentMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentInput = {
  metadata?: InputMaybe<DocumentMetadataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  horizons?: Maybe<DocumentMetadataHorizons>;
  lastModifiedDate?: Maybe<Scalars['Date']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DocumentMetadataHorizons = {
  __typename?: 'DocumentMetadataHorizons';
  damageId?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  dossierId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type DocumentMetadataHorizonsInput = {
  damageId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  dossierId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMetadataInput = {
  horizons?: InputMaybe<DocumentMetadataHorizonsInput>;
  lastModifiedDate?: InputMaybe<Scalars['Date']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dossier = {
  __typename?: 'Dossier';
  abTesting?: Maybe<Array<Maybe<AbTesting>>>;
  appointment?: Maybe<Appointment>;
  call?: Maybe<Array<Maybe<Call>>>;
  canNotifyCustomer?: Maybe<Scalars['Boolean']['output']>;
  claim?: Maybe<Claim>;
  createDate?: Maybe<Scalars['Date']['output']>;
  creationData?: Maybe<CreationData>;
  currentlyInUse?: Maybe<CurrentlyInUseInfos>;
  customer?: Maybe<Customer>;
  declarationPage?: Maybe<Scalars['String']['output']>;
  dossierComments?: Maybe<Array<Maybe<DossierComments>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<DossierExternalReferences>;
  fitterInfo?: Maybe<FitterInfo>;
  gpdr?: Maybe<GpdrData>;
  id: Scalars['ID']['output'];
  insurer?: Maybe<Insurer>;
  insurerData?: Maybe<InsurerData>;
  marketingData?: Maybe<MarketingData>;
  nps?: Maybe<Array<Maybe<DossierNps>>>;
  policyInformation?: Maybe<PolicyInformation>;
  previousAppointments?: Maybe<Array<Maybe<Appointment>>>;
  requestAppointment?: Maybe<RequestAppointment>;
  searchCriteria?: Maybe<DossierSearchLocation>;
  selectedLanguage?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateHistory?: Maybe<Array<Maybe<DossierStateHistory>>>;
  suggestedAppointments?: Maybe<Array<Maybe<Appointment>>>;
  updateDate?: Maybe<Scalars['Date']['output']>;
};

export type DossierAdvancedFiltersInput = {
  appointmentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dossierGlobalOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dossierNum?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum DossierAgendaConcurencyAction {
  Close = 'Close',
  Open = 'Open'
}

export type DossierAgendaFiltersInput = {
  appointmentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  areFitterSelected?: InputMaybe<Scalars['Boolean']['input']>;
  dossierGlobalOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dossierNum?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  genericSearch?: InputMaybe<Scalars['String']['input']>;
  isValidatedByFitter?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  replacementVehicle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  technician?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DossierAgendaOverlapFiltersInput = {
  locations: Array<EventLocationInput>;
  periods: Array<PeriodInput>;
};

export type DossierByCustomerName = {
  __typename?: 'DossierByCustomerName';
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  licensePlateNumber?: Maybe<Scalars['String']['output']>;
};

export type DossierComments = {
  __typename?: 'DossierComments';
  comment: Scalars['String']['output'];
  commentType: Scalars['String']['output'];
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  timestamp: Scalars['Date']['output'];
  userName: Scalars['String']['output'];
};

export type DossierCommentsInput = {
  comment: Scalars['String']['input'];
  commentType?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  userName: Scalars['String']['input'];
};

export type DossierExternalReferences = {
  __typename?: 'DossierExternalReferences';
  damageId?: Maybe<Scalars['String']['output']>;
  horizonsId?: Maybe<Scalars['String']['output']>;
};

export type DossierExternalReferencesInput = {
  damageId?: InputMaybe<Scalars['String']['input']>;
  horizonsId?: InputMaybe<Scalars['String']['input']>;
};

export type DossierInput = {
  abTesting?: InputMaybe<Array<InputMaybe<AbTestingInput>>>;
  appointment?: InputMaybe<AppointmentInput>;
  call?: InputMaybe<Array<InputMaybe<CallInput>>>;
  canNotifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  claim?: InputMaybe<ClaimInput>;
  customer?: InputMaybe<CustomerInput>;
  declarationPage?: InputMaybe<Scalars['String']['input']>;
  dossierComments?: InputMaybe<Array<InputMaybe<DossierCommentsInput>>>;
  externalReferences?: InputMaybe<DossierExternalReferencesInput>;
  fitterInfo?: InputMaybe<FitterInfoInput>;
  gpdr?: InputMaybe<GpdrDataInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insurer?: InputMaybe<InsurerInput>;
  insurerData?: InputMaybe<InsurerDataInput>;
  marketingData?: InputMaybe<MarketingDataInput>;
  nps?: InputMaybe<Array<InputMaybe<DossierNpsInput>>>;
  policyInformation?: InputMaybe<PolicyInformationInput>;
  requestAppointment?: InputMaybe<RequestAppointmentInput>;
  searchCriteria?: InputMaybe<DossierSearchLocationInput>;
  selectedLanguage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suggestedAppointments?: InputMaybe<Array<InputMaybe<AppointmentInput>>>;
};

export type DossierNps = {
  __typename?: 'DossierNps';
  appOrigin?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  userSkipped?: Maybe<Scalars['Boolean']['output']>;
};

export type DossierNpsInput = {
  appOrigin?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  userSkipped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DossierSearchLocation = {
  __typename?: 'DossierSearchLocation';
  address?: Maybe<LocationDataGeocoded>;
  filters?: Maybe<SearchFilters>;
};

export type DossierSearchLocationInput = {
  address?: InputMaybe<LocationDataGeocodedInput>;
  filters?: InputMaybe<SearchFiltersInput>;
};

export type DossierStateHistory = {
  __typename?: 'DossierStateHistory';
  data?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type DossierStateHistoryInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type EchoResponse = {
  __typename?: 'EchoResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type Error = {
  __typename?: 'Error';
  code?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Event = {
  __typename?: 'Event';
  clientKey: Scalars['String']['output'];
  closeDossier?: Maybe<CloseDossier>;
  departingDossier?: Maybe<DepartingDossier>;
  echoResponse?: Maybe<EchoResponse>;
  errors?: Maybe<Array<Maybe<Error>>>;
  freeSlotsResults?: Maybe<FreeSlotsResult>;
  newDossier?: Maybe<NewDossier>;
  openDossier?: Maybe<OpenDossier>;
  timestamp: Scalars['String']['output'];
  updatedDossier?: Maybe<UpdatedDossier>;
};

export enum EventLocationInput {
  Center = 'center',
  Outside = 'outside'
}

export type FilterLabels = {
  __typename?: 'FilterLabels';
  interventionVehicleLabel?: Maybe<Scalars['String']['output']>;
  replacementVehicleLabel?: Maybe<Scalars['String']['output']>;
  technicianLabel?: Maybe<Scalars['String']['output']>;
};

export type Fitter = {
  __typename?: 'Fitter';
  address?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactList?: Maybe<Array<Maybe<FitterContact>>>;
  cp?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fceId?: Maybe<Scalars['String']['output']>;
  filterLabels?: Maybe<FilterLabels>;
  fitterType?: Maybe<Scalars['String']['output']>;
  google?: Maybe<FitterGoogleData>;
  id: Scalars['ID']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  interventionVehicles?: Maybe<Array<Maybe<FitterResource>>>;
  location?: Maybe<GeoCoordinatesFitter>;
  managers?: Maybe<Array<Maybe<FitterManager>>>;
  maxMobilityParallelJob?: Maybe<Scalars['Int']['output']>;
  maxParallelJob?: Maybe<Scalars['Int']['output']>;
  mobilityZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  openingHours?: Maybe<FitterOpeningHours>;
  phone?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<FitterResource>>>;
  serviceTypes?: Maybe<Array<Maybe<FitterServiceType>>>;
  siret?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  useTechAvailabilityForOutisdeIntervention?: Maybe<Scalars['Boolean']['output']>;
  vehicles?: Maybe<Array<Maybe<FitterVehicle>>>;
};

export type FitterBaseInput = {
  address: Scalars['String']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactList?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  cp: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  filterLabels?: InputMaybe<Scalars['JSON']['input']>;
  fitterType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  internalId?: InputMaybe<Scalars['String']['input']>;
  interventionVehicles?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  managers?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  openingHours?: InputMaybe<Scalars['JSON']['input']>;
  phone: Scalars['String']['input'];
  resources?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  serviceTypes?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  siret?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FitterContact = {
  __typename?: 'FitterContact';
  activeEmail?: Maybe<Scalars['Boolean']['output']>;
  activePhone?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<PhoneNumber>;
};

export type FitterGoogleData = {
  __typename?: 'FitterGoogleData';
  business_status?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoCoordinatesFitter>;
  name?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  user_ratings_total?: Maybe<Scalars['Float']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type FitterInfo = {
  __typename?: 'FitterInfo';
  isReadyToBill?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FitterInfoInput = {
  isReadyToBill?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FitterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactList?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  cp?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filterLabels?: InputMaybe<Scalars['JSON']['input']>;
  fitterType?: InputMaybe<Scalars['String']['input']>;
  google?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  internalId?: InputMaybe<Scalars['String']['input']>;
  interventionVehicles?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  managers?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  maxMobilityParallelJob?: InputMaybe<Scalars['Int']['input']>;
  maxParallelJob?: InputMaybe<Scalars['Int']['input']>;
  mobilityZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openingHours?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  serviceTypes?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  siret?: InputMaybe<Scalars['String']['input']>;
  useTechAvailabilityForOutisdeIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FitterInterventionsCreateInput = {
  id: Scalars['String']['input'];
  interventions?: InputMaybe<Array<InputMaybe<InterventionCreateInput>>>;
};

export type FitterInterventionsInput = {
  id: Scalars['String']['input'];
  interventions?: InputMaybe<Array<InputMaybe<InterventionInput>>>;
};

export type FitterManager = {
  __typename?: 'FitterManager';
  accessTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fitterComment?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type FitterMasterSearchInput = {
  hashIndex?: InputMaybe<Scalars['Int']['input']>;
  hashModulo?: InputMaybe<Scalars['Int']['input']>;
};

export type FitterMobilityZoneInput = {
  fitters?: InputMaybe<Scalars['JSON']['input']>;
};

export type FitterMobilityZoneUpdateResponse = {
  __typename?: 'FitterMobilityZoneUpdateResponse';
  errors: Array<Scalars['String']['output']>;
  updated: Array<Scalars['String']['output']>;
};

export type FitterOpeningHours = {
  __typename?: 'FitterOpeningHours';
  center?: Maybe<Array<Maybe<FitterOpeningPeriod>>>;
  outside?: Maybe<Array<Maybe<FitterOpeningPeriod>>>;
  webCenter?: Maybe<Array<Maybe<FitterOpeningPeriod>>>;
  webOutside?: Maybe<Array<Maybe<FitterOpeningPeriod>>>;
};

export type FitterOpeningHoursInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Array<InputMaybe<FitterOpeningPeriodInput>>>;
};

export type FitterOpeningLimit = {
  __typename?: 'FitterOpeningLimit';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type FitterOpeningLimitInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type FitterOpeningPeriod = {
  __typename?: 'FitterOpeningPeriod';
  close?: Maybe<FitterOpeningLimit>;
  open?: Maybe<FitterOpeningLimit>;
};

export type FitterOpeningPeriodInput = {
  close?: InputMaybe<FitterOpeningLimitInput>;
  open?: InputMaybe<FitterOpeningLimitInput>;
};

export type FitterReplacementVehicle = {
  __typename?: 'FitterReplacementVehicle';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licensePlateNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FitterReplacementVehicleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  licensePlateNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FitterResource = {
  __typename?: 'FitterResource';
  active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FitterSearchInput = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  codeFce?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cp?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hashIndex?: InputMaybe<Scalars['Int']['input']>;
  hashModulo?: InputMaybe<Scalars['Int']['input']>;
};

export type FitterServiceType = {
  __typename?: 'FitterServiceType';
  active?: Maybe<Scalars['Boolean']['output']>;
  calibration?: Maybe<Scalars['Boolean']['output']>;
  canBookOnline?: Maybe<Scalars['Boolean']['output']>;
  canMakeInCenterIntervention?: Maybe<Scalars['Boolean']['output']>;
  canMakeOutsideIntervention?: Maybe<Scalars['Boolean']['output']>;
  canShareReplacementVehicle?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  glassType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interventionDuration?: Maybe<Scalars['Int']['output']>;
  interventionDurationMobility?: Maybe<Scalars['Int']['output']>;
  mobilityOffSet?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offSet?: Maybe<Scalars['Int']['output']>;
  operationType?: Maybe<Scalars['String']['output']>;
  slotAvailability?: Maybe<FitterSlotAvailability>;
  weekendOffset?: Maybe<FitterweekendOffset>;
};

export type FitterSlotAvailability = {
  __typename?: 'FitterSlotAvailability';
  cutOffs?: Maybe<FitterSlotAvailabilityCutOffs>;
  mode?: Maybe<Scalars['String']['output']>;
};

export type FitterSlotAvailabilityCutOffs = {
  __typename?: 'FitterSlotAvailabilityCutOffs';
  afternoon?: Maybe<Scalars['String']['output']>;
  morning?: Maybe<Scalars['String']['output']>;
};

export type FitterSlotAvailabilityCutOffsInput = {
  afternoon?: InputMaybe<Scalars['String']['input']>;
  morning?: InputMaybe<Scalars['String']['input']>;
};

export type FitterSlotAvailabilityInput = {
  cutOffs?: InputMaybe<FitterSlotAvailabilityCutOffsInput>;
  mode?: InputMaybe<Scalars['String']['input']>;
};

export type FitterStatistic = {
  __typename?: 'FitterStatistic';
  brandId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insuranceStat?: Maybe<Scalars['JSON']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
};

export type FitterStatisticInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  insuranceStat?: InputMaybe<Scalars['JSON']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
};

export type FitterVehicle = {
  __typename?: 'FitterVehicle';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licensePlateNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FitterweekendOffset = {
  __typename?: 'FitterweekendOffset';
  endDay?: Maybe<Scalars['Int']['output']>;
  endHour?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  offSet?: Maybe<Scalars['Int']['output']>;
  startDay?: Maybe<Scalars['Int']['output']>;
  startHour?: Maybe<Scalars['String']['output']>;
};

export type FitterweekendOffsetInput = {
  endDay?: InputMaybe<Scalars['Int']['input']>;
  endHour?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  startDay?: InputMaybe<Scalars['Int']['input']>;
  startHour?: InputMaybe<Scalars['String']['input']>;
};

export type FreeSlotsResult = {
  __typename?: 'FreeSlotsResult';
  appointments?: Maybe<Scalars['JSON']['output']>;
  dotFitters?: Maybe<Scalars['JSON']['output']>;
  fitter?: Maybe<Scalars['JSON']['output']>;
  globalScores?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['JSON']['output']>;
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
};

export type GeoCoordinatesFitter = {
  __typename?: 'GeoCoordinatesFitter';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
};

export type GeoCoordinatesInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
};

export type GlassImpact = {
  __typename?: 'GlassImpact';
  atOuterEdge?: Maybe<Scalars['Boolean']['output']>;
  impactsType?: Maybe<Scalars['String']['output']>;
  inVisionField?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type GlassImpactInput = {
  atOuterEdge?: InputMaybe<Scalars['Boolean']['input']>;
  impactsType?: InputMaybe<Scalars['String']['input']>;
  inVisionField?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type GpdrData = {
  __typename?: 'GpdrData';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
};

export type GpdrDataInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
};

export type InUsePeriod = {
  __typename?: 'InUsePeriod';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type InUsePeriodInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type Insurer = {
  __typename?: 'Insurer';
  code?: Maybe<Scalars['String']['output']>;
};

export type InsurerData = {
  __typename?: 'InsurerData';
  abandonmentComment?: Maybe<Scalars['String']['output']>;
  callAgent?: Maybe<Scalars['String']['output']>;
  callAgentFirstname?: Maybe<Scalars['String']['output']>;
  callAgentLastname?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  dossierId?: Maybe<Scalars['Int']['output']>;
  finishLaterComment?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  rriNumber?: Maybe<Scalars['String']['output']>;
};

export type InsurerDataInput = {
  abandonmentComment?: InputMaybe<Scalars['String']['input']>;
  callAgent?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dossierId?: InputMaybe<Scalars['Int']['input']>;
  finishLaterComment?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  rriNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InsurerInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type InterventionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  calibration: Scalars['Boolean']['input'];
  canBookOnline: Scalars['Boolean']['input'];
  canMakeInCenterIntervention: Scalars['Boolean']['input'];
  canMakeOutsideIntervention: Scalars['Boolean']['input'];
  canShareReplacementVehicle: Scalars['Boolean']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  glassType: Scalars['String']['input'];
  interventionDuration: Scalars['Int']['input'];
  interventionDurationMobility?: InputMaybe<Scalars['Int']['input']>;
  mobilityOffSet?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offSet: Scalars['Int']['input'];
  operationType: Scalars['String']['input'];
  slotAvailability?: InputMaybe<FitterSlotAvailabilityInput>;
};

export type InterventionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  calibration?: InputMaybe<Scalars['Boolean']['input']>;
  canBookOnline?: InputMaybe<Scalars['Boolean']['input']>;
  canMakeInCenterIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  canMakeOutsideIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  canShareReplacementVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  glassType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  interventionDuration?: InputMaybe<Scalars['Int']['input']>;
  interventionDurationMobility?: InputMaybe<Scalars['Int']['input']>;
  mobilityOffSet?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  operationType: Scalars['String']['input'];
  slotAvailability?: InputMaybe<FitterSlotAvailabilityInput>;
  weekendOffset?: InputMaybe<FitterweekendOffsetInput>;
};

export type InterventionParams = {
  __typename?: 'InterventionParams';
  displayGeneralists?: Maybe<Scalars['Boolean']['output']>;
  displayGlassSpecialist?: Maybe<Scalars['Boolean']['output']>;
  fitterIntervention?: Maybe<Scalars['Boolean']['output']>;
  outsideIntervention?: Maybe<Scalars['Boolean']['output']>;
  replacementVehicle?: Maybe<Scalars['Boolean']['output']>;
};

export type InterventionParamsInput = {
  displayGeneralists?: InputMaybe<Scalars['Boolean']['input']>;
  displayGlassSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  fitterIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  outsideIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  replacementVehicle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Itinerary = {
  __typename?: 'Itinerary';
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
};

export type ItineraryInput = {
  distance?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
};

export type LateralPrecisions = {
  __typename?: 'LateralPrecisions';
  frontConductor?: Maybe<Scalars['String']['output']>;
  precision?: Maybe<Scalars['String']['output']>;
};

export type LateralPrecisionsInput = {
  frontConductor?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['String']['input']>;
};

export type Light = {
  __typename?: 'Light';
  lateral?: Maybe<Scalars['String']['output']>;
  lightsEmplacement?: Maybe<Scalars['String']['output']>;
};

export type LightInput = {
  lateral?: InputMaybe<Scalars['String']['input']>;
  lightsEmplacement?: InputMaybe<Scalars['String']['input']>;
};

export type LocationDataGeocoded = {
  __typename?: 'LocationDataGeocoded';
  address?: Maybe<Scalars['String']['output']>;
  addressElements?: Maybe<AddressElements>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  isCompleteAddress?: Maybe<Scalars['Boolean']['output']>;
  isKnownAddress?: Maybe<Scalars['Boolean']['output']>;
  locationProvider?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type LocationDataGeocodedInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressElements?: InputMaybe<AddressElementsInput>;
  geoCoordinates?: InputMaybe<GeoCoordinatesInput>;
  isCompleteAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isKnownAddress?: InputMaybe<Scalars['Boolean']['input']>;
  locationProvider?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingData = {
  __typename?: 'MarketingData';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
};

export type MarketingDataInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  abandonDossier?: Maybe<AbandonDossierResult>;
  bulkCreateEvent?: Maybe<Array<Maybe<AgendaEvent>>>;
  bulkCreateFitterInterventions?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateFitterInterventions?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateFitterMobilityZones?: Maybe<FitterMobilityZoneUpdateResponse>;
  bulkUpdateOpeningHoursWebInCenter?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateOpeningHoursWebOutsideIntervention?: Maybe<Scalars['Boolean']['output']>;
  changeDossierLanguage?: Maybe<Scalars['Boolean']['output']>;
  clear?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createDossier?: Maybe<Dossier>;
  createEvent?: Maybe<AgendaEvent>;
  createFitter?: Maybe<Fitter>;
  deleteAll?: Maybe<Scalars['Int']['output']>;
  deleteDossier?: Maybe<Scalars['String']['output']>;
  deleteEvent?: Maybe<Scalars['Boolean']['output']>;
  deleteFitter?: Maybe<Scalars['Boolean']['output']>;
  dossierAgendaConcurency?: Maybe<Scalars['Boolean']['output']>;
  poll?: Maybe<Event>;
  resetDossier?: Maybe<Dossier>;
  saveChatComments?: Maybe<Dossier>;
  saveDraftDossier?: Maybe<Dossier>;
  setHorizonsIdToDossier?: Maybe<Dossier>;
  unregisterKey?: Maybe<Ack>;
  updateDossier?: Maybe<Dossier>;
  updateEvent?: Maybe<AgendaEvent>;
  updateFitter?: Maybe<Fitter>;
  updateFitterComment?: Maybe<Fitter>;
};


export type MutationAbandonDossierArgs = {
  abandonmentComment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationBulkCreateEventArgs = {
  events?: InputMaybe<Array<InputMaybe<AgendaEventInput>>>;
};


export type MutationBulkCreateFitterInterventionsArgs = {
  fitterInterventions: Array<InputMaybe<FitterInterventionsCreateInput>>;
};


export type MutationBulkUpdateFitterInterventionsArgs = {
  fitterInterventions: Array<InputMaybe<FitterInterventionsInput>>;
};


export type MutationBulkUpdateFitterMobilityZonesArgs = {
  fittersMobilityZones: FitterMobilityZoneInput;
};


export type MutationBulkUpdateOpeningHoursWebInCenterArgs = {
  fittersOpeningHours: Array<InputMaybe<FitterOpeningHoursInput>>;
};


export type MutationBulkUpdateOpeningHoursWebOutsideInterventionArgs = {
  fittersOpeningHours: Array<InputMaybe<FitterOpeningHoursInput>>;
};


export type MutationChangeDossierLanguageArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDossierArgs = {
  dossier?: InputMaybe<DossierInput>;
};


export type MutationCreateEventArgs = {
  event?: InputMaybe<AgendaEventInput>;
};


export type MutationCreateFitterArgs = {
  fitter: FitterBaseInput;
};


export type MutationDeleteDossierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFitterArgs = {
  brandId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDossierAgendaConcurencyArgs = {
  concurencyAction: DossierAgendaConcurencyAction;
  id: Scalars['ID']['input'];
};


export type MutationPollArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetDossierArgs = {
  dossier?: InputMaybe<DossierInput>;
};


export type MutationSaveChatCommentsArgs = {
  updateComments: UpdateDossierCommentsInput;
};


export type MutationSaveDraftDossierArgs = {
  dossier?: InputMaybe<DossierInput>;
};


export type MutationSetHorizonsIdToDossierArgs = {
  horizonsId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUnregisterKeyArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDossierArgs = {
  dossier?: InputMaybe<DossierInput>;
};


export type MutationUpdateEventArgs = {
  event?: InputMaybe<AgendaEventInput>;
};


export type MutationUpdateFitterArgs = {
  fitter: FitterInput;
};


export type MutationUpdateFitterCommentArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type NewDossier = {
  __typename?: 'NewDossier';
  dossierId?: Maybe<Scalars['String']['output']>;
};

export enum NotificationTypeEnum {
  Email = 'Email',
  Sms = 'SMS',
  WhatsApp = 'WhatsApp'
}

export enum NotificationTypeEnumInput {
  Email = 'Email',
  Sms = 'SMS',
  WhatsApp = 'WhatsApp'
}

export type OpenDossier = {
  __typename?: 'OpenDossier';
  dossierId?: Maybe<Scalars['String']['output']>;
};

export type PeriodInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCode?: Maybe<Scalars['String']['output']>;
  internationalCode?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  internationalCode?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyInformation = {
  __typename?: 'PolicyInformation';
  coverBDG?: Maybe<Scalars['String']['output']>;
  excessTakeover?: Maybe<Scalars['String']['output']>;
  insuranceChoice?: Maybe<Scalars['String']['output']>;
  insuranceCode?: Maybe<Scalars['String']['output']>;
  insuranceEndDate?: Maybe<Scalars['Date']['output']>;
  insuranceName?: Maybe<Scalars['String']['output']>;
  insuranceStartDate?: Maybe<Scalars['Date']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  insuredFirstname?: Maybe<Scalars['String']['output']>;
  insuredLastname?: Maybe<Scalars['String']['output']>;
  insuredPhoneNumber?: Maybe<Scalars['String']['output']>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isCancelledWithoutPayment?: Maybe<Scalars['Boolean']['output']>;
  isCovered?: Maybe<Scalars['Boolean']['output']>;
  isGuaranteeConditionRetrieveWithSuccess?: Maybe<Scalars['Boolean']['output']>;
  isSuspended?: Maybe<Scalars['Boolean']['output']>;
  maxRepairDeductible?: Maybe<Scalars['Int']['output']>;
  maxReplacementDeductible?: Maybe<Scalars['Int']['output']>;
  minRepairDeductible?: Maybe<Scalars['Int']['output']>;
  minReplacementDeductible?: Maybe<Scalars['Int']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  repairDeductible?: Maybe<Scalars['Int']['output']>;
  repairGuaranteeCeiling?: Maybe<Scalars['Int']['output']>;
  repairRateDeductible?: Maybe<Scalars['Int']['output']>;
  replacementDeductible?: Maybe<Scalars['Int']['output']>;
  replacementGuaranteeCeiling?: Maybe<Scalars['Int']['output']>;
  replacementRateDeductible?: Maybe<Scalars['Int']['output']>;
  sinisterNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type PolicyInformationInput = {
  coverBDG?: InputMaybe<Scalars['String']['input']>;
  excessTakeover?: InputMaybe<Scalars['String']['input']>;
  insuranceChoice?: InputMaybe<Scalars['String']['input']>;
  insuranceCode?: InputMaybe<Scalars['String']['input']>;
  insuranceEndDate?: InputMaybe<Scalars['Date']['input']>;
  insuranceName?: InputMaybe<Scalars['String']['input']>;
  insuranceStartDate?: InputMaybe<Scalars['Date']['input']>;
  insuredEmail?: InputMaybe<Scalars['String']['input']>;
  insuredFirstname?: InputMaybe<Scalars['String']['input']>;
  insuredLastname?: InputMaybe<Scalars['String']['input']>;
  insuredPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelledWithoutPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isCovered?: InputMaybe<Scalars['Boolean']['input']>;
  isGuaranteeConditionRetrieveWithSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  maxRepairDeductible?: InputMaybe<Scalars['Int']['input']>;
  maxReplacementDeductible?: InputMaybe<Scalars['Int']['input']>;
  minRepairDeductible?: InputMaybe<Scalars['Int']['input']>;
  minReplacementDeductible?: InputMaybe<Scalars['Int']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  repairDeductible?: InputMaybe<Scalars['Int']['input']>;
  repairGuaranteeCeiling?: InputMaybe<Scalars['Int']['input']>;
  repairRateDeductible?: InputMaybe<Scalars['Int']['input']>;
  replacementDeductible?: InputMaybe<Scalars['Int']['input']>;
  replacementGuaranteeCeiling?: InputMaybe<Scalars['Int']['input']>;
  replacementRateDeductible?: InputMaybe<Scalars['Int']['input']>;
  sinisterNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PostalCodeToCitiesMap = {
  __typename?: 'PostalCodeToCitiesMap';
  cities: Array<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  dossier?: Maybe<Dossier>;
  dossierByHorizonsId?: Maybe<Dossier>;
  dossierBySinisterNumber?: Maybe<Dossier>;
  dossiers?: Maybe<Array<Maybe<Dossier>>>;
  echo?: Maybe<Ack>;
  echoDirect?: Maybe<Ack>;
  event?: Maybe<AgendaEvent>;
  events?: Maybe<Array<Maybe<AgendaEvent>>>;
  fitter?: Maybe<Fitter>;
  fitterStatistics?: Maybe<Array<Maybe<FitterStatistic>>>;
  fitters?: Maybe<Array<Maybe<Fitter>>>;
  getAllFittersById?: Maybe<Array<Maybe<Fitter>>>;
  getCoveredCities: Array<PostalCodeToCitiesMap>;
  getFitterByManager?: Maybe<Fitter>;
  getFittersByManager?: Maybe<Array<Maybe<Fitter>>>;
  registerPolling?: Maybe<Ack>;
  searchDossierByCustomerName?: Maybe<Array<Maybe<DossierByCustomerName>>>;
  searchDossiers?: Maybe<Array<Maybe<Dossier>>>;
  searchDossiersAgenda?: Maybe<Array<Maybe<Dossier>>>;
  searchDossiersAgendaOverlap?: Maybe<Array<Maybe<Dossier>>>;
  searchDossiersRequestedApmtAgenda?: Maybe<Array<Maybe<Dossier>>>;
  searchDossiersToValidateAgenda?: Maybe<Array<Maybe<Dossier>>>;
  searchFitters?: Maybe<Array<Maybe<Fitter>>>;
  searchMasterFitters?: Maybe<Array<Maybe<Fitter>>>;
};


export type QueryDossierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDossierByHorizonsIdArgs = {
  horizonsId: Scalars['String']['input'];
};


export type QueryDossierBySinisterNumberArgs = {
  sinisterNumber: Scalars['String']['input'];
};


export type QueryEchoArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEchoDirectArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventsArgs = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  fitterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFitterArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryFitterStatisticsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFittersArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  distance: Scalars['Int']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  onlyAgendaFitters?: InputMaybe<Scalars['Boolean']['input']>;
  shouldWidenSearch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAllFittersByIdArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryGetCoveredCitiesArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetFitterByManagerArgs = {
  id: Scalars['String']['input'];
};


export type QueryRegisterPollingArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchDossierByCustomerNameArgs = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  fitterId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchDossiersArgs = {
  advancedFilters?: InputMaybe<DossierAdvancedFiltersInput>;
  appointmentDates?: InputMaybe<SearchDatesInput>;
  creationDates?: InputMaybe<SearchDatesInput>;
  fitters?: InputMaybe<Array<InputMaybe<SearchFittersInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySearchDossiersAgendaArgs = {
  filters?: InputMaybe<DossierAgendaFiltersInput>;
  fitterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySearchDossiersAgendaOverlapArgs = {
  filters: DossierAgendaOverlapFiltersInput;
  fitterIds: Array<Scalars['String']['input']>;
};


export type QuerySearchDossiersRequestedApmtAgendaArgs = {
  fitterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchDossiersToValidateAgendaArgs = {
  fitterIds: Array<Scalars['String']['input']>;
};


export type QuerySearchFittersArgs = {
  filters?: InputMaybe<FitterSearchInput>;
};


export type QuerySearchMasterFittersArgs = {
  filters?: InputMaybe<FitterMasterSearchInput>;
};

export type RequestAppointment = {
  __typename?: 'RequestAppointment';
  assignedInterventionVehicle?: Maybe<Scalars['String']['output']>;
  assignedReplacementVehicle?: Maybe<FitterReplacementVehicle>;
  assignedReplacementVehicleUse?: Maybe<InUsePeriod>;
  assignedResources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  extraCost?: Maybe<Scalars['Float']['output']>;
  fitterId?: Maybe<Scalars['String']['output']>;
  immobilisationDuration?: Maybe<Scalars['Int']['output']>;
  interventionId?: Maybe<Scalars['String']['output']>;
  interventionLocation?: Maybe<LocationDataGeocoded>;
  isConveying?: Maybe<Scalars['Boolean']['output']>;
  isInterventionDifficult?: Maybe<Scalars['Boolean']['output']>;
  isReplacementVehicleSelected?: Maybe<Scalars['Boolean']['output']>;
  isValidatedByFitter?: Maybe<Scalars['Boolean']['output']>;
  itinerary?: Maybe<Itinerary>;
  outsideIntervention?: Maybe<Scalars['Boolean']['output']>;
  partAvailability?: Maybe<Scalars['String']['output']>;
  partProvider?: Maybe<Scalars['String']['output']>;
  reminderIsSent?: Maybe<Scalars['Boolean']['output']>;
  replacementVehicle?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type RequestAppointmentInput = {
  assignedInterventionVehicle?: InputMaybe<Scalars['String']['input']>;
  assignedReplacementVehicle?: InputMaybe<FitterReplacementVehicleInput>;
  assignedReplacementVehicleUse?: InputMaybe<InUsePeriodInput>;
  assignedResources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  extraCost?: InputMaybe<Scalars['Float']['input']>;
  fitterId?: InputMaybe<Scalars['String']['input']>;
  immobilisationDuration?: InputMaybe<Scalars['Int']['input']>;
  interventionId?: InputMaybe<Scalars['String']['input']>;
  interventionLocation?: InputMaybe<LocationDataGeocodedInput>;
  isConveying?: InputMaybe<Scalars['Boolean']['input']>;
  isInterventionDifficult?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacementVehicleSelected?: InputMaybe<Scalars['Boolean']['input']>;
  isValidatedByFitter?: InputMaybe<Scalars['Boolean']['input']>;
  itinerary?: InputMaybe<ItineraryInput>;
  outsideIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  partAvailability?: InputMaybe<Scalars['String']['input']>;
  partProvider?: InputMaybe<Scalars['String']['input']>;
  reminderIsSent?: InputMaybe<Scalars['Boolean']['input']>;
  replacementVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalCost?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchDatesInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type SearchFilters = {
  __typename?: 'SearchFilters';
  groupBy?: Maybe<Scalars['String']['output']>;
  interventionParams?: Maybe<InterventionParams>;
  period?: Maybe<TimeFilters>;
};

export type SearchFiltersInput = {
  groupBy?: InputMaybe<Scalars['String']['input']>;
  interventionParams?: InputMaybe<InterventionParamsInput>;
  period?: InputMaybe<TimeFiltersInput>;
};

export type SearchFittersInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  fitterId?: InputMaybe<Scalars['String']['input']>;
};

export type SinisterContext = {
  __typename?: 'SinisterContext';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SinisterContextInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SinisterGlass = {
  __typename?: 'SinisterGlass';
  glass?: Maybe<Scalars['String']['output']>;
  glassExtended?: Maybe<Scalars['String']['output']>;
  impacts?: Maybe<GlassImpact>;
  lateralPrecisions?: Maybe<LateralPrecisions>;
  light?: Maybe<Light>;
  mirror?: Maybe<Scalars['String']['output']>;
};

export type SinisterGlassInput = {
  glass?: InputMaybe<Scalars['String']['input']>;
  glassExtended?: InputMaybe<Scalars['String']['input']>;
  impacts?: InputMaybe<GlassImpactInput>;
  lateralPrecisions?: InputMaybe<LateralPrecisionsInput>;
  light?: InputMaybe<LightInput>;
  mirror?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  myEvent: Event;
  myEventDirect: Event;
};


export type SubscriptionMyEventArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionMyEventDirectArgs = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
};

export type TimeFilters = {
  __typename?: 'TimeFilters';
  end?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type TimeFiltersInput = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDossierCommentsInput = {
  comments?: InputMaybe<Array<InputMaybe<DossierCommentsInput>>>;
  idDossier: Scalars['String']['input'];
};

export type UpdatedDossier = {
  __typename?: 'UpdatedDossier';
  dossierId?: Maybe<Scalars['String']['output']>;
  updateType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type File = {
  __typename?: 'file';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type EventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EventQuery = { __typename?: 'Query', event?: { __typename?: 'AgendaEvent', id: string, brandId?: string | null, fitterId?: string | null, comment?: string | null, type?: string | null, title?: string | null, startTime?: any | null, endTime?: any | null, timezone?: string | null, createDate?: any | null, updateDate?: any | null, allDay?: boolean | null, locations?: Array<string> | null, additionalData?: any | null, resources?: Array<{ __typename?: 'AgendaEventFitterResource', name?: string | null } | null> | null, creationData?: { __typename?: 'AgendaEventCreationData', code?: string | null, email?: string | null, origin?: string | null } | null, recurrent?: { __typename?: 'AgendaEventRecurrence', startDate?: string | null, endDate?: string | null, freq?: string | null, every?: number | null, daysOfWeek?: Array<number> | null, daysDeletes?: Array<{ __typename?: 'AgendaRecurrencePeriodDelete', startDate?: string | null, endDate?: string | null }> | null } | null } | null };

export type EventsQueryVariables = Exact<{
  fitterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  eventType?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'AgendaEvent', id: string, brandId?: string | null, fitterId?: string | null, comment?: string | null, type?: string | null, title?: string | null, startTime?: any | null, endTime?: any | null, timezone?: string | null, createDate?: any | null, updateDate?: any | null, allDay?: boolean | null, locations?: Array<string> | null, additionalData?: any | null, resources?: Array<{ __typename?: 'AgendaEventFitterResource', name?: string | null } | null> | null, creationData?: { __typename?: 'AgendaEventCreationData', code?: string | null, email?: string | null, origin?: string | null } | null, recurrent?: { __typename?: 'AgendaEventRecurrence', startDate?: string | null, endDate?: string | null, freq?: string | null, every?: number | null, daysOfWeek?: Array<number> | null, daysDeletes?: Array<{ __typename?: 'AgendaRecurrencePeriodDelete', startDate?: string | null, endDate?: string | null }> | null } | null } | null> | null };

export type CreateEventMutationVariables = Exact<{
  event: AgendaEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent?: { __typename?: 'AgendaEvent', brandId?: string | null, fitterId?: string | null, comment?: string | null, type?: string | null, title?: string | null, startTime?: any | null, endTime?: any | null, timezone?: string | null, allDay?: boolean | null, locations?: Array<string> | null, additionalData?: any | null, resources?: Array<{ __typename?: 'AgendaEventFitterResource', name?: string | null } | null> | null, recurrent?: { __typename?: 'AgendaEventRecurrence', startDate?: string | null, endDate?: string | null, freq?: string | null, every?: number | null, daysOfWeek?: Array<number> | null, daysDeletes?: Array<{ __typename?: 'AgendaRecurrencePeriodDelete', startDate?: string | null, endDate?: string | null }> | null } | null } | null };

export type BulkCreateEventMutationVariables = Exact<{
  events: Array<InputMaybe<AgendaEventInput>> | InputMaybe<AgendaEventInput>;
}>;


export type BulkCreateEventMutation = { __typename?: 'Mutation', bulkCreateEvent?: Array<{ __typename?: 'AgendaEvent', brandId?: string | null, fitterId?: string | null, comment?: string | null, type?: string | null, title?: string | null, startTime?: any | null, endTime?: any | null, timezone?: string | null, allDay?: boolean | null, locations?: Array<string> | null, additionalData?: any | null, resources?: Array<{ __typename?: 'AgendaEventFitterResource', name?: string | null } | null> | null, recurrent?: { __typename?: 'AgendaEventRecurrence', startDate?: string | null, endDate?: string | null, freq?: string | null, every?: number | null, daysOfWeek?: Array<number> | null, daysDeletes?: Array<{ __typename?: 'AgendaRecurrencePeriodDelete', startDate?: string | null, endDate?: string | null }> | null } | null } | null> | null };

export type UpdateEventMutationVariables = Exact<{
  event: AgendaEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent?: { __typename?: 'AgendaEvent', id: string, brandId?: string | null, fitterId?: string | null, comment?: string | null, type?: string | null, title?: string | null, startTime?: any | null, endTime?: any | null, timezone?: string | null, allDay?: boolean | null, locations?: Array<string> | null, additionalData?: any | null, resources?: Array<{ __typename?: 'AgendaEventFitterResource', name?: string | null } | null> | null, recurrent?: { __typename?: 'AgendaEventRecurrence', startDate?: string | null, endDate?: string | null, freq?: string | null, every?: number | null, daysOfWeek?: Array<number> | null, daysDeletes?: Array<{ __typename?: 'AgendaRecurrencePeriodDelete', startDate?: string | null, endDate?: string | null }> | null } | null } | null };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: boolean | null };

export type GetFittersByManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFittersByManagerQuery = { __typename?: 'Query', getFittersByManager?: Array<{ __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, timezone?: string | null, maxParallelJob?: number | null, maxMobilityParallelJob?: number | null, useTechAvailabilityForOutisdeIntervention?: boolean | null, mobilityZones?: Array<string | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null, vehicles?: Array<{ __typename?: 'FitterVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null> | null, serviceTypes?: Array<{ __typename?: 'FitterServiceType', id?: string | null, name?: string | null, glassType?: string | null, operationType?: string | null, interventionDuration?: number | null, interventionDurationMobility?: number | null, canBookOnline?: boolean | null, canMakeInCenterIntervention?: boolean | null, canMakeOutsideIntervention?: boolean | null, canShareReplacementVehicle?: boolean | null, color?: string | null, active?: boolean | null, default?: boolean | null, offSet?: number | null, mobilityOffSet?: number | null, calibration?: boolean | null, weekendOffset?: { __typename?: 'FitterweekendOffset', isActive?: boolean | null, offSet?: number | null, startDay?: number | null, startHour?: string | null, endDay?: number | null, endHour?: string | null } | null, slotAvailability?: { __typename?: 'FitterSlotAvailability', mode?: string | null, cutOffs?: { __typename?: 'FitterSlotAvailabilityCutOffs', morning?: string | null, afternoon?: string | null } | null } | null } | null> | null, managers?: Array<{ __typename?: 'FitterManager', email?: string | null, fitterComment?: string | null, lastName?: string | null, firstName?: string | null, accessTypes?: Array<string | null> | null } | null> | null, contactList?: Array<{ __typename?: 'FitterContact', name?: string | null, email?: string | null, activeEmail?: boolean | null, activePhone?: boolean | null, phone?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null> | null, resources?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, interventionVehicles?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, filterLabels?: { __typename?: 'FilterLabels', technicianLabel?: string | null, interventionVehicleLabel?: string | null, replacementVehicleLabel?: string | null } | null, google?: { __typename?: 'FitterGoogleData', place_id?: string | null } | null } | null> | null };

export type GetFitterByManagerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetFitterByManagerQuery = { __typename?: 'Query', getFitterByManager?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, maxParallelJob?: number | null, maxMobilityParallelJob?: number | null, useTechAvailabilityForOutisdeIntervention?: boolean | null, mobilityZones?: Array<string | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, google?: { __typename?: 'FitterGoogleData', place_id?: string | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null, vehicles?: Array<{ __typename?: 'FitterVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null> | null, serviceTypes?: Array<{ __typename?: 'FitterServiceType', id?: string | null, name?: string | null, glassType?: string | null, operationType?: string | null, interventionDuration?: number | null, interventionDurationMobility?: number | null, canBookOnline?: boolean | null, canMakeInCenterIntervention?: boolean | null, canMakeOutsideIntervention?: boolean | null, canShareReplacementVehicle?: boolean | null, color?: string | null, active?: boolean | null, default?: boolean | null, offSet?: number | null, mobilityOffSet?: number | null, calibration?: boolean | null, weekendOffset?: { __typename?: 'FitterweekendOffset', isActive?: boolean | null, offSet?: number | null, startDay?: number | null, startHour?: string | null, endDay?: number | null, endHour?: string | null } | null, slotAvailability?: { __typename?: 'FitterSlotAvailability', mode?: string | null, cutOffs?: { __typename?: 'FitterSlotAvailabilityCutOffs', morning?: string | null, afternoon?: string | null } | null } | null } | null> | null, managers?: Array<{ __typename?: 'FitterManager', email?: string | null, fitterComment?: string | null, lastName?: string | null, firstName?: string | null, accessTypes?: Array<string | null> | null } | null> | null, contactList?: Array<{ __typename?: 'FitterContact', name?: string | null, email?: string | null, activeEmail?: boolean | null, activePhone?: boolean | null, phone?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null> | null, resources?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, interventionVehicles?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, filterLabels?: { __typename?: 'FilterLabels', technicianLabel?: string | null, interventionVehicleLabel?: string | null, replacementVehicleLabel?: string | null } | null } | null };

export type GetAllFittersByIdQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAllFittersByIdQuery = { __typename?: 'Query', getAllFittersById?: Array<{ __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, timezone?: string | null, maxParallelJob?: number | null, maxMobilityParallelJob?: number | null, useTechAvailabilityForOutisdeIntervention?: boolean | null, mobilityZones?: Array<string | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null, vehicles?: Array<{ __typename?: 'FitterVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null> | null, serviceTypes?: Array<{ __typename?: 'FitterServiceType', id?: string | null, name?: string | null, glassType?: string | null, operationType?: string | null, interventionDuration?: number | null, interventionDurationMobility?: number | null, canBookOnline?: boolean | null, canMakeInCenterIntervention?: boolean | null, canMakeOutsideIntervention?: boolean | null, canShareReplacementVehicle?: boolean | null, color?: string | null, active?: boolean | null, default?: boolean | null, offSet?: number | null, mobilityOffSet?: number | null, calibration?: boolean | null, weekendOffset?: { __typename?: 'FitterweekendOffset', isActive?: boolean | null, offSet?: number | null, startDay?: number | null, startHour?: string | null, endDay?: number | null, endHour?: string | null } | null, slotAvailability?: { __typename?: 'FitterSlotAvailability', mode?: string | null, cutOffs?: { __typename?: 'FitterSlotAvailabilityCutOffs', morning?: string | null, afternoon?: string | null } | null } | null } | null> | null, managers?: Array<{ __typename?: 'FitterManager', email?: string | null, fitterComment?: string | null, lastName?: string | null, firstName?: string | null, accessTypes?: Array<string | null> | null } | null> | null, contactList?: Array<{ __typename?: 'FitterContact', name?: string | null, email?: string | null, activeEmail?: boolean | null, activePhone?: boolean | null, phone?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null> | null, resources?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, interventionVehicles?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, filterLabels?: { __typename?: 'FilterLabels', technicianLabel?: string | null, interventionVehicleLabel?: string | null, replacementVehicleLabel?: string | null } | null, google?: { __typename?: 'FitterGoogleData', place_id?: string | null } | null } | null> | null };

export type GetCoveredCitiesQueryVariables = Exact<{
  fitterId: Scalars['String']['input'];
}>;


export type GetCoveredCitiesQuery = { __typename?: 'Query', getCoveredCities: Array<{ __typename?: 'PostalCodeToCitiesMap', postalCode: string, cities: Array<string> }> };

export type UpdateAgendaFitterMutationVariables = Exact<{
  fitter: FitterInput;
}>;


export type UpdateAgendaFitterMutation = { __typename?: 'Mutation', updateFitter?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, maxParallelJob?: number | null, maxMobilityParallelJob?: number | null, useTechAvailabilityForOutisdeIntervention?: boolean | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null, vehicles?: Array<{ __typename?: 'FitterVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null> | null, serviceTypes?: Array<{ __typename?: 'FitterServiceType', id?: string | null, name?: string | null, glassType?: string | null, operationType?: string | null, interventionDuration?: number | null, interventionDurationMobility?: number | null, canBookOnline?: boolean | null, canMakeInCenterIntervention?: boolean | null, canMakeOutsideIntervention?: boolean | null, canShareReplacementVehicle?: boolean | null, color?: string | null, active?: boolean | null, default?: boolean | null, offSet?: number | null, calibration?: boolean | null, weekendOffset?: { __typename?: 'FitterweekendOffset', isActive?: boolean | null, offSet?: number | null, startDay?: number | null, startHour?: string | null, endDay?: number | null, endHour?: string | null } | null, slotAvailability?: { __typename?: 'FitterSlotAvailability', mode?: string | null, cutOffs?: { __typename?: 'FitterSlotAvailabilityCutOffs', morning?: string | null, afternoon?: string | null } | null } | null } | null> | null, managers?: Array<{ __typename?: 'FitterManager', email?: string | null, fitterComment?: string | null, lastName?: string | null, firstName?: string | null, accessTypes?: Array<string | null> | null } | null> | null, contactList?: Array<{ __typename?: 'FitterContact', name?: string | null, email?: string | null, activeEmail?: boolean | null, activePhone?: boolean | null, phone?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null> | null, resources?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, interventionVehicles?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, filterLabels?: { __typename?: 'FilterLabels', technicianLabel?: string | null, interventionVehicleLabel?: string | null, replacementVehicleLabel?: string | null } | null } | null };

export type UpdateFitterCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
}>;


export type UpdateFitterCommentMutation = { __typename?: 'Mutation', updateFitterComment?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, maxParallelJob?: number | null, maxMobilityParallelJob?: number | null, useTechAvailabilityForOutisdeIntervention?: boolean | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, google?: { __typename?: 'FitterGoogleData', name?: string | null, place_id?: string | null, rating?: number | null, formatted_address?: string | null, business_status?: string | null, website?: string | null, user_ratings_total?: number | null, review?: Array<any | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null, vehicles?: Array<{ __typename?: 'FitterVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null> | null, serviceTypes?: Array<{ __typename?: 'FitterServiceType', id?: string | null, name?: string | null, glassType?: string | null, operationType?: string | null, interventionDuration?: number | null, interventionDurationMobility?: number | null, canBookOnline?: boolean | null, canMakeInCenterIntervention?: boolean | null, canMakeOutsideIntervention?: boolean | null, canShareReplacementVehicle?: boolean | null, color?: string | null, active?: boolean | null, default?: boolean | null, offSet?: number | null, calibration?: boolean | null, weekendOffset?: { __typename?: 'FitterweekendOffset', isActive?: boolean | null, offSet?: number | null, startDay?: number | null, startHour?: string | null, endDay?: number | null, endHour?: string | null } | null, slotAvailability?: { __typename?: 'FitterSlotAvailability', mode?: string | null, cutOffs?: { __typename?: 'FitterSlotAvailabilityCutOffs', morning?: string | null, afternoon?: string | null } | null } | null } | null> | null, managers?: Array<{ __typename?: 'FitterManager', email?: string | null, fitterComment?: string | null, lastName?: string | null, firstName?: string | null, accessTypes?: Array<string | null> | null } | null> | null, contactList?: Array<{ __typename?: 'FitterContact', name?: string | null, email?: string | null, activeEmail?: boolean | null, activePhone?: boolean | null, phone?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null> | null, resources?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, interventionVehicles?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, filterLabels?: { __typename?: 'FilterLabels', technicianLabel?: string | null, interventionVehicleLabel?: string | null, replacementVehicleLabel?: string | null } | null } | null };

export type CreateAgendaFitterMutationVariables = Exact<{
  fitter: FitterBaseInput;
}>;


export type CreateAgendaFitterMutation = { __typename?: 'Mutation', createFitter?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, maxParallelJob?: number | null, maxMobilityParallelJob?: number | null, useTechAvailabilityForOutisdeIntervention?: boolean | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null, vehicles?: Array<{ __typename?: 'FitterVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null> | null, serviceTypes?: Array<{ __typename?: 'FitterServiceType', id?: string | null, name?: string | null, glassType?: string | null, operationType?: string | null, interventionDuration?: number | null, interventionDurationMobility?: number | null, canBookOnline?: boolean | null, canMakeInCenterIntervention?: boolean | null, canMakeOutsideIntervention?: boolean | null, canShareReplacementVehicle?: boolean | null, color?: string | null, active?: boolean | null, default?: boolean | null, offSet?: number | null, calibration?: boolean | null, weekendOffset?: { __typename?: 'FitterweekendOffset', isActive?: boolean | null, offSet?: number | null, startDay?: number | null, startHour?: string | null, endDay?: number | null, endHour?: string | null } | null, slotAvailability?: { __typename?: 'FitterSlotAvailability', mode?: string | null, cutOffs?: { __typename?: 'FitterSlotAvailabilityCutOffs', morning?: string | null, afternoon?: string | null } | null } | null } | null> | null, managers?: Array<{ __typename?: 'FitterManager', email?: string | null, fitterComment?: string | null, lastName?: string | null, firstName?: string | null, accessTypes?: Array<string | null> | null } | null> | null, contactList?: Array<{ __typename?: 'FitterContact', name?: string | null, email?: string | null, activeEmail?: boolean | null, activePhone?: boolean | null, phone?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null> | null, resources?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, interventionVehicles?: Array<{ __typename?: 'FitterResource', active?: boolean | null, name?: string | null } | null> | null, filterLabels?: { __typename?: 'FilterLabels', technicianLabel?: string | null, interventionVehicleLabel?: string | null, replacementVehicleLabel?: string | null } | null } | null };

export type BulkUpdateOpeningHoursWebInCenterMutationVariables = Exact<{
  fittersOpeningHours: Array<InputMaybe<FitterOpeningHoursInput>> | InputMaybe<FitterOpeningHoursInput>;
}>;


export type BulkUpdateOpeningHoursWebInCenterMutation = { __typename?: 'Mutation', bulkUpdateOpeningHoursWebInCenter?: boolean | null };

export type BulkUpdateOpeningHoursWebOutsideInterventionMutationVariables = Exact<{
  fittersOpeningHours: Array<InputMaybe<FitterOpeningHoursInput>> | InputMaybe<FitterOpeningHoursInput>;
}>;


export type BulkUpdateOpeningHoursWebOutsideInterventionMutation = { __typename?: 'Mutation', bulkUpdateOpeningHoursWebOutsideIntervention?: boolean | null };

export type DossierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DossierQuery = { __typename?: 'Query', dossier?: { __typename?: 'Dossier', id: string, selectedLanguage?: string | null, state?: string | null, createDate?: any | null, updateDate?: any | null, externalId?: string | null, canNotifyCustomer?: boolean | null, declarationPage?: string | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, claim?: { __typename?: 'Claim', sinisterDate?: any | null, operationType?: string | null, sinisterComment?: string | null, sinisterLocation?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', registrationCode?: string | null, countryCode?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, firstRegistration?: any | null, parts?: Array<any | null> | null, vinNumber?: string | null, vehicleType?: string | null, ownerShip?: { __typename?: 'CarOwnerShipData', type?: string | null, name?: string | null } | null, characteristics?: { __typename?: 'CarCharacteristics', registration?: string | null, registrationType?: string | null, color?: string | null, energy?: string | null, cylinders?: number | null, numberOfDoors?: number | null, propulsionType?: string | null, chassisNumber?: string | null, modelYear?: number | null, engineNumber?: string | null, gearboxType?: string | null, gearboxNbSpeed?: number | null, gearboxNumber?: string | null, unloadedWeight?: number | null, horsepower?: number | null, fiscalPower?: number | null, kwPower?: number | null, totalRollingWeight?: number | null, co2Emission?: number | null } | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null, sinisterContext?: { __typename?: 'SinisterContext', key?: string | null, value?: string | null } | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, birthDate?: any | null, location?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, billingLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, insurerData?: { __typename?: 'InsurerData', dossierId?: number | null, callAgent?: string | null, callAgentFirstname?: string | null, callAgentLastname?: string | null, comment?: string | null, other?: string | null, abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, policyInformation?: { __typename?: 'PolicyInformation', insuranceChoice?: string | null, insuranceName?: string | null, insuranceCode?: string | null, policyNumber?: string | null, vatNumber?: string | null, insuredFirstname?: string | null, insuredLastname?: string | null, insuredEmail?: string | null, insuredPhoneNumber?: string | null, insuranceStartDate?: any | null, insuranceEndDate?: any | null, isGuaranteeConditionRetrieveWithSuccess?: boolean | null, isCancelled?: boolean | null, isCancelledWithoutPayment?: boolean | null, isSuspended?: boolean | null, isCovered?: boolean | null, coverBDG?: string | null, excessTakeover?: string | null, replacementDeductible?: number | null, repairDeductible?: number | null, replacementRateDeductible?: number | null, repairRateDeductible?: number | null, minReplacementDeductible?: number | null, maxReplacementDeductible?: number | null, minRepairDeductible?: number | null, maxRepairDeductible?: number | null, replacementGuaranteeCeiling?: number | null, repairGuaranteeCeiling?: number | null, sinisterNumber?: string | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, endTime?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, partProvider?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, previousAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null> | null, suggestedAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null> | null, gpdr?: { __typename?: 'GpdrData', accepted?: boolean | null, time?: any | null } | null, marketingData?: { __typename?: 'MarketingData', accepted?: boolean | null, time?: any | null } | null, call?: Array<{ __typename?: 'Call', callSid?: string | null, status?: string | null, creationDate?: any | null, callDuration?: number | null, phoneNumberTo?: string | null, phoneNumberFrom?: string | null, userCaller?: string | null, userCallee?: string | null, callReason?: string | null, conferenceName?: string | null } | null> | null, searchCriteria?: { __typename?: 'DossierSearchLocation', address?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, filters?: { __typename?: 'SearchFilters', groupBy?: string | null, period?: { __typename?: 'TimeFilters', start?: number | null, end?: number | null } | null, interventionParams?: { __typename?: 'InterventionParams', outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, fitterIntervention?: boolean | null, displayGeneralists?: boolean | null, displayGlassSpecialist?: boolean | null } | null } | null } | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null, nps?: Array<{ __typename?: 'DossierNps', score?: number | null, comment?: string | null, userSkipped?: boolean | null, appOrigin?: string | null, timestamp?: any | null } | null> | null, abTesting?: Array<{ __typename?: 'AbTesting', abTestType?: string | null, value?: boolean | null } | null> | null } | null };

export type DossierBySinisterNumberQueryVariables = Exact<{
  sinisterNumber: Scalars['String']['input'];
}>;


export type DossierBySinisterNumberQuery = { __typename?: 'Query', dossierBySinisterNumber?: { __typename?: 'Dossier', id: string, selectedLanguage?: string | null, state?: string | null, createDate?: any | null, updateDate?: any | null, externalId?: string | null, canNotifyCustomer?: boolean | null, declarationPage?: string | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, claim?: { __typename?: 'Claim', sinisterDate?: any | null, operationType?: string | null, sinisterComment?: string | null, sinisterLocation?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', registrationCode?: string | null, countryCode?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, firstRegistration?: any | null, parts?: Array<any | null> | null, vinNumber?: string | null, vehicleType?: string | null, ownerShip?: { __typename?: 'CarOwnerShipData', type?: string | null, name?: string | null } | null, characteristics?: { __typename?: 'CarCharacteristics', registration?: string | null, registrationType?: string | null, color?: string | null, energy?: string | null, cylinders?: number | null, numberOfDoors?: number | null, propulsionType?: string | null, chassisNumber?: string | null, modelYear?: number | null, engineNumber?: string | null, gearboxType?: string | null, gearboxNbSpeed?: number | null, gearboxNumber?: string | null, unloadedWeight?: number | null, horsepower?: number | null, fiscalPower?: number | null, kwPower?: number | null, totalRollingWeight?: number | null, co2Emission?: number | null } | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null } | null } | null> | null, sinisterContext?: { __typename?: 'SinisterContext', key?: string | null, value?: string | null } | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, birthDate?: any | null, location?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, billingLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, insurerData?: { __typename?: 'InsurerData', dossierId?: number | null, callAgent?: string | null, callAgentFirstname?: string | null, callAgentLastname?: string | null, comment?: string | null, other?: string | null, abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, policyInformation?: { __typename?: 'PolicyInformation', insuranceChoice?: string | null, insuranceName?: string | null, insuranceCode?: string | null, policyNumber?: string | null, vatNumber?: string | null, insuredFirstname?: string | null, insuredLastname?: string | null, insuredEmail?: string | null, insuredPhoneNumber?: string | null, insuranceStartDate?: any | null, insuranceEndDate?: any | null, isGuaranteeConditionRetrieveWithSuccess?: boolean | null, isCancelled?: boolean | null, isCancelledWithoutPayment?: boolean | null, isSuspended?: boolean | null, isCovered?: boolean | null, coverBDG?: string | null, excessTakeover?: string | null, replacementDeductible?: number | null, repairDeductible?: number | null, replacementRateDeductible?: number | null, repairRateDeductible?: number | null, minReplacementDeductible?: number | null, maxReplacementDeductible?: number | null, minRepairDeductible?: number | null, maxRepairDeductible?: number | null, replacementGuaranteeCeiling?: number | null, repairGuaranteeCeiling?: number | null, sinisterNumber?: string | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, endTime?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, partProvider?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, previousAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null> | null, suggestedAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null> | null, gpdr?: { __typename?: 'GpdrData', accepted?: boolean | null, time?: any | null } | null, marketingData?: { __typename?: 'MarketingData', accepted?: boolean | null, time?: any | null } | null, call?: Array<{ __typename?: 'Call', callSid?: string | null, status?: string | null, creationDate?: any | null, callDuration?: number | null, phoneNumberTo?: string | null, phoneNumberFrom?: string | null, userCaller?: string | null, userCallee?: string | null, callReason?: string | null, conferenceName?: string | null } | null> | null, searchCriteria?: { __typename?: 'DossierSearchLocation', address?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, filters?: { __typename?: 'SearchFilters', groupBy?: string | null, period?: { __typename?: 'TimeFilters', start?: number | null, end?: number | null } | null, interventionParams?: { __typename?: 'InterventionParams', outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, fitterIntervention?: boolean | null, displayGeneralists?: boolean | null, displayGlassSpecialist?: boolean | null } | null } | null } | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null, nps?: Array<{ __typename?: 'DossierNps', score?: number | null, comment?: string | null, userSkipped?: boolean | null, appOrigin?: string | null, timestamp?: any | null } | null> | null, abTesting?: Array<{ __typename?: 'AbTesting', abTestType?: string | null, value?: boolean | null } | null> | null } | null };

export type SearchDossiersQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  creationDates?: InputMaybe<SearchDatesInput>;
  fitters?: InputMaybe<Array<InputMaybe<SearchFittersInput>> | InputMaybe<SearchFittersInput>>;
  advancedFilters?: InputMaybe<DossierAdvancedFiltersInput>;
}>;


export type SearchDossiersQuery = { __typename?: 'Query', searchDossiers?: Array<{ __typename?: 'Dossier', id: string, state?: string | null, createDate?: any | null, updateDate?: any | null, declarationPage?: string | null, claim?: { __typename?: 'Claim', sinisterDate?: any | null, operationType?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, vehicleType?: string | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, insurerData?: { __typename?: 'InsurerData', abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, marketingData?: { __typename?: 'MarketingData', accepted?: boolean | null, time?: any | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, outsideIntervention?: boolean | null, status?: string | null, comment?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, outsideIntervention?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, comment?: string | null, isConveying?: boolean | null, interventionId?: string | null, isValidatedByFitter?: boolean | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, searchCriteria?: { __typename?: 'DossierSearchLocation', address?: { __typename?: 'LocationDataGeocoded', address?: string | null } | null } | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null, nps?: Array<{ __typename?: 'DossierNps', score?: number | null, comment?: string | null, userSkipped?: boolean | null, appOrigin?: string | null, timestamp?: any | null } | null> | null, abTesting?: Array<{ __typename?: 'AbTesting', abTestType?: string | null, value?: boolean | null } | null> | null } | null> | null };

export type SearchDossiersAgendaQueryVariables = Exact<{
  fitterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<DossierAgendaFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDossiersAgendaQuery = { __typename?: 'Query', searchDossiersAgenda?: Array<{ __typename?: 'Dossier', id: string, state?: string | null, createDate?: any | null, updateDate?: any | null, claim?: { __typename?: 'Claim', sinisterDate?: any | null, operationType?: string | null, sinisterLocation?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, vehicleType?: string | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, sinisterContext?: { __typename?: 'SinisterContext', key?: string | null, value?: string | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null } | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, insurerData?: { __typename?: 'InsurerData', abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, endTime?: any | null, outsideIntervention?: boolean | null, status?: string | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, isReplacementVehicleSelected?: boolean | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null } | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null } | null> | null };

export type SearchDossiersAgendaOverlapQueryVariables = Exact<{
  fitterIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filters: DossierAgendaOverlapFiltersInput;
}>;


export type SearchDossiersAgendaOverlapQuery = { __typename?: 'Query', searchDossiersAgendaOverlap?: Array<{ __typename?: 'Dossier', id: string, state?: string | null, createDate?: any | null, updateDate?: any | null, claim?: { __typename?: 'Claim', sinisterComment?: string | null, sinisterDate?: any | null, operationType?: string | null, sinisterLocation?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, vehicleType?: string | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, sinisterContext?: { __typename?: 'SinisterContext', key?: string | null, value?: string | null } | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null } | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, insurerData?: { __typename?: 'InsurerData', abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, endTime?: any | null, outsideIntervention?: boolean | null, status?: string | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, isReplacementVehicleSelected?: boolean | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null } | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null } | null> | null };

export type SearchDossiersToValidateAgendaQueryVariables = Exact<{
  fitterIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchDossiersToValidateAgendaQuery = { __typename?: 'Query', searchDossiersToValidateAgenda?: Array<{ __typename?: 'Dossier', id: string, state?: string | null, createDate?: any | null, updateDate?: any | null, claim?: { __typename?: 'Claim', sinisterComment?: string | null, sinisterDate?: any | null, operationType?: string | null, sinisterLocation?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, vehicleType?: string | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, sinisterContext?: { __typename?: 'SinisterContext', key?: string | null, value?: string | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null } | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, insurerData?: { __typename?: 'InsurerData', abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, endTime?: any | null, outsideIntervention?: boolean | null, status?: string | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, isReplacementVehicleSelected?: boolean | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null } | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null } | null> | null };

export type SearchDossiersRequestedApmtAgendaQueryVariables = Exact<{
  fitterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDossiersRequestedApmtAgendaQuery = { __typename?: 'Query', searchDossiersRequestedApmtAgenda?: Array<{ __typename?: 'Dossier', id: string, state?: string | null, createDate?: any | null, updateDate?: any | null, claim?: { __typename?: 'Claim', sinisterComment?: string | null, sinisterDate?: any | null, operationType?: string | null, sinisterLocation?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', licensePlateNumber?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, vehicleType?: string | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, sinisterContext?: { __typename?: 'SinisterContext', key?: string | null, value?: string | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null } | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, insurerData?: { __typename?: 'InsurerData', abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, endTime?: any | null, outsideIntervention?: boolean | null, status?: string | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, isReplacementVehicleSelected?: boolean | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', address?: string | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null } | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null } | null> | null };

export type SearchDossierByCustomerNameQueryVariables = Exact<{
  customerName?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  fitterId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchDossierByCustomerNameQuery = { __typename?: 'Query', searchDossierByCustomerName?: Array<{ __typename?: 'DossierByCustomerName', id?: string | null, customerName?: string | null, customerFirstName?: string | null, licensePlateNumber?: string | null } | null> | null };

export type UpdateDossierMutationVariables = Exact<{
  dossier: DossierInput;
}>;


export type UpdateDossierMutation = { __typename?: 'Mutation', updateDossier?: { __typename?: 'Dossier', id: string, selectedLanguage?: string | null, state?: string | null, createDate?: any | null, updateDate?: any | null, canNotifyCustomer?: boolean | null, declarationPage?: string | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, stateHistory?: Array<{ __typename?: 'DossierStateHistory', userType?: string | null, state?: string | null, timestamp?: any | null, data?: any | null, userName?: string | null } | null> | null, claim?: { __typename?: 'Claim', sinisterComment?: string | null, sinisterDate?: any | null, operationType?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', registrationCode?: string | null, licensePlateNumber?: string | null, countryCode?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, firstRegistration?: any | null, parts?: Array<any | null> | null, vinNumber?: string | null, vehicleType?: string | null, ownerShip?: { __typename?: 'CarOwnerShipData', type?: string | null, name?: string | null } | null, characteristics?: { __typename?: 'CarCharacteristics', registration?: string | null, registrationType?: string | null, color?: string | null, energy?: string | null, cylinders?: number | null, numberOfDoors?: number | null, propulsionType?: string | null, chassisNumber?: string | null, modelYear?: number | null, engineNumber?: string | null, gearboxType?: string | null, gearboxNbSpeed?: number | null, gearboxNumber?: string | null, unloadedWeight?: number | null, horsepower?: number | null, fiscalPower?: number | null, kwPower?: number | null, totalRollingWeight?: number | null, co2Emission?: number | null } | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, birthDate?: any | null, location?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, billingLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurerData?: { __typename?: 'InsurerData', dossierId?: number | null, callAgent?: string | null, callAgentFirstname?: string | null, callAgentLastname?: string | null, comment?: string | null, other?: string | null, abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, policyInformation?: { __typename?: 'PolicyInformation', insuranceChoice?: string | null, insuranceName?: string | null, insuranceCode?: string | null, policyNumber?: string | null, vatNumber?: string | null, insuredFirstname?: string | null, insuredLastname?: string | null, insuredEmail?: string | null, insuredPhoneNumber?: string | null, insuranceStartDate?: any | null, insuranceEndDate?: any | null, isGuaranteeConditionRetrieveWithSuccess?: boolean | null, isCancelled?: boolean | null, isCancelledWithoutPayment?: boolean | null, isSuspended?: boolean | null, isCovered?: boolean | null, coverBDG?: string | null, excessTakeover?: string | null, replacementDeductible?: number | null, repairDeductible?: number | null, replacementRateDeductible?: number | null, repairRateDeductible?: number | null, minReplacementDeductible?: number | null, maxReplacementDeductible?: number | null, minRepairDeductible?: number | null, maxRepairDeductible?: number | null, replacementGuaranteeCeiling?: number | null, repairGuaranteeCeiling?: number | null, sinisterNumber?: string | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, comment?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null, previousAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null> | null, suggestedAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, itinerary?: { __typename?: 'Itinerary', duration?: number | null, distance?: number | null } | null } | null> | null, gpdr?: { __typename?: 'GpdrData', accepted?: boolean | null, time?: any | null } | null, marketingData?: { __typename?: 'MarketingData', accepted?: boolean | null, time?: any | null } | null, call?: Array<{ __typename?: 'Call', callSid?: string | null, status?: string | null, creationDate?: any | null, callDuration?: number | null, phoneNumberTo?: string | null, phoneNumberFrom?: string | null, userCaller?: string | null, userCallee?: string | null, callReason?: string | null, conferenceName?: string | null } | null> | null, searchCriteria?: { __typename?: 'DossierSearchLocation', address?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, filters?: { __typename?: 'SearchFilters', groupBy?: string | null, period?: { __typename?: 'TimeFilters', start?: number | null, end?: number | null } | null, interventionParams?: { __typename?: 'InterventionParams', outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, fitterIntervention?: boolean | null, displayGeneralists?: boolean | null, displayGlassSpecialist?: boolean | null } | null } | null } | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null, nps?: Array<{ __typename?: 'DossierNps', score?: number | null, comment?: string | null, userSkipped?: boolean | null, appOrigin?: string | null, timestamp?: any | null } | null> | null, abTesting?: Array<{ __typename?: 'AbTesting', abTestType?: string | null, value?: boolean | null } | null> | null } | null };

export type SaveDraftDossierMutationVariables = Exact<{
  dossier: DossierInput;
}>;


export type SaveDraftDossierMutation = { __typename?: 'Mutation', saveDraftDossier?: { __typename?: 'Dossier', id: string, selectedLanguage?: string | null, state?: string | null, createDate?: any | null, updateDate?: any | null, declarationPage?: string | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, claim?: { __typename?: 'Claim', sinisterComment?: string | null, sinisterDate?: any | null, operationType?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', registrationCode?: string | null, licensePlateNumber?: string | null, countryCode?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, firstRegistration?: any | null, parts?: Array<any | null> | null, vinNumber?: string | null, vehicleType?: string | null, ownerShip?: { __typename?: 'CarOwnerShipData', type?: string | null, name?: string | null } | null, characteristics?: { __typename?: 'CarCharacteristics', registration?: string | null, registrationType?: string | null, color?: string | null, energy?: string | null, cylinders?: number | null, numberOfDoors?: number | null, propulsionType?: string | null, chassisNumber?: string | null, modelYear?: number | null, engineNumber?: string | null, gearboxType?: string | null, gearboxNbSpeed?: number | null, gearboxNumber?: string | null, unloadedWeight?: number | null, horsepower?: number | null, fiscalPower?: number | null, kwPower?: number | null, totalRollingWeight?: number | null, co2Emission?: number | null } | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, birthDate?: any | null, location?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, billingLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurerData?: { __typename?: 'InsurerData', dossierId?: number | null, callAgent?: string | null, callAgentFirstname?: string | null, callAgentLastname?: string | null, comment?: string | null, other?: string | null, abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, policyInformation?: { __typename?: 'PolicyInformation', insuranceChoice?: string | null, insuranceName?: string | null, insuranceCode?: string | null, policyNumber?: string | null, vatNumber?: string | null, insuredFirstname?: string | null, insuredLastname?: string | null, insuredEmail?: string | null, insuredPhoneNumber?: string | null, isGuaranteeConditionRetrieveWithSuccess?: boolean | null, isCancelled?: boolean | null, isCancelledWithoutPayment?: boolean | null, isSuspended?: boolean | null, coverBDG?: string | null, excessTakeover?: string | null, sinisterNumber?: string | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, comment?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null } | null, previousAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null } | null> | null, suggestedAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null } | null> | null, gpdr?: { __typename?: 'GpdrData', accepted?: boolean | null, time?: any | null } | null, marketingData?: { __typename?: 'MarketingData', accepted?: boolean | null, time?: any | null } | null, call?: Array<{ __typename?: 'Call', callSid?: string | null, status?: string | null, creationDate?: any | null, callDuration?: number | null, phoneNumberTo?: string | null, phoneNumberFrom?: string | null, userCaller?: string | null, userCallee?: string | null, callReason?: string | null, conferenceName?: string | null } | null> | null, searchCriteria?: { __typename?: 'DossierSearchLocation', address?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, filters?: { __typename?: 'SearchFilters', groupBy?: string | null, period?: { __typename?: 'TimeFilters', start?: number | null, end?: number | null } | null, interventionParams?: { __typename?: 'InterventionParams', outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, fitterIntervention?: boolean | null, displayGeneralists?: boolean | null, displayGlassSpecialist?: boolean | null } | null } | null } | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null } | null };

export type ChangeDossierLanguageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeDossierLanguageMutation = { __typename?: 'Mutation', changeDossierLanguage?: boolean | null };

export type AbandonDossierMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  abandonmentComment?: InputMaybe<Scalars['String']['input']>;
}>;


export type AbandonDossierMutation = { __typename?: 'Mutation', abandonDossier?: { __typename?: 'AbandonDossierResult', abandonned: boolean, dossierForContractManager?: any | null } | null };

export type SendDossierConcurencyActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  concurencyAction: DossierAgendaConcurencyAction;
}>;


export type SendDossierConcurencyActionMutation = { __typename?: 'Mutation', dossierAgendaConcurency?: boolean | null };

export type SaveChatCommentsMutationVariables = Exact<{
  updateComments: UpdateDossierCommentsInput;
}>;


export type SaveChatCommentsMutation = { __typename?: 'Mutation', saveChatComments?: { __typename?: 'Dossier', id: string, selectedLanguage?: string | null, state?: string | null, createDate?: any | null, updateDate?: any | null, declarationPage?: string | null, creationData?: { __typename?: 'CreationData', code?: string | null, email?: string | null, origin?: string | null, businessOrigin?: string | null } | null, claim?: { __typename?: 'Claim', sinisterComment?: string | null, sinisterDate?: any | null, operationType?: string | null, calibration?: string | null, eurocode?: string | null, constructorRef?: string | null, sinisterPlace?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, car?: { __typename?: 'Car', registrationCode?: string | null, licensePlateNumber?: string | null, countryCode?: string | null, manufacturer?: string | null, version?: string | null, model?: string | null, firstRegistration?: any | null, parts?: Array<any | null> | null, vinNumber?: string | null, vehicleType?: string | null, ownerShip?: { __typename?: 'CarOwnerShipData', type?: string | null, name?: string | null } | null, characteristics?: { __typename?: 'CarCharacteristics', registration?: string | null, registrationType?: string | null, color?: string | null, energy?: string | null, cylinders?: number | null, numberOfDoors?: number | null, propulsionType?: string | null, chassisNumber?: string | null, modelYear?: number | null, engineNumber?: string | null, gearboxType?: string | null, gearboxNbSpeed?: number | null, gearboxNumber?: string | null, unloadedWeight?: number | null, horsepower?: number | null, fiscalPower?: number | null, kwPower?: number | null, totalRollingWeight?: number | null, co2Emission?: number | null } | null } | null, glass?: { __typename?: 'SinisterGlass', glass?: string | null, glassExtended?: string | null, mirror?: string | null, impacts?: { __typename?: 'GlassImpact', size?: string | null, impactsType?: string | null, inVisionField?: boolean | null, atOuterEdge?: boolean | null } | null, lateralPrecisions?: { __typename?: 'LateralPrecisions', frontConductor?: string | null, precision?: string | null } | null, light?: { __typename?: 'Light', lateral?: string | null, lightsEmplacement?: string | null } | null } | null, documents?: Array<{ __typename?: 'Document', type?: string | null, url?: string | null, name?: string | null, metadata?: { __typename?: 'DocumentMetadata', lastModifiedDate?: any | null, name?: string | null, mimeType?: string | null, horizons?: { __typename?: 'DocumentMetadataHorizons', dossierId?: string | null, reference?: string | null, damageId?: string | null, documentId?: string | null } | null } | null } | null> | null } | null, fitterInfo?: { __typename?: 'FitterInfo', message?: string | null, isReadyToBill?: boolean | null } | null, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, birthDate?: any | null, location?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, billingLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, internationalCode?: string | null, countryCode?: string | null } | null } | null, insurer?: { __typename?: 'Insurer', code?: string | null } | null, currentlyInUse?: { __typename?: 'CurrentlyInUseInfos', userId?: string | null, userName?: string | null, timestamp?: string | null } | null, insurerData?: { __typename?: 'InsurerData', dossierId?: number | null, callAgent?: string | null, callAgentFirstname?: string | null, callAgentLastname?: string | null, comment?: string | null, other?: string | null, abandonmentComment?: string | null, finishLaterComment?: string | null, rriNumber?: string | null } | null, policyInformation?: { __typename?: 'PolicyInformation', insuranceChoice?: string | null, insuranceName?: string | null, insuranceCode?: string | null, policyNumber?: string | null, vatNumber?: string | null, insuredFirstname?: string | null, insuredLastname?: string | null, insuredEmail?: string | null, insuredPhoneNumber?: string | null, isGuaranteeConditionRetrieveWithSuccess?: boolean | null, isCancelled?: boolean | null, isCancelledWithoutPayment?: boolean | null, isSuspended?: boolean | null, coverBDG?: string | null, excessTakeover?: string | null, sinisterNumber?: string | null } | null, appointment?: { __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, comment?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null, assignedReplacementVehicleUse?: { __typename?: 'InUsePeriod', start?: string | null, end?: string | null } | null } | null, requestAppointment?: { __typename?: 'RequestAppointment', fitterId?: string | null, brandId?: string | null, timezone?: string | null, immobilisationDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isValidatedByFitter?: boolean | null, comment?: string | null, partAvailability?: string | null, assignedResources?: Array<string | null> | null, assignedInterventionVehicle?: string | null, partProvider?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, assignedReplacementVehicle?: { __typename?: 'FitterReplacementVehicle', id?: string | null, name?: string | null, licensePlateNumber?: string | null, manufacturer?: string | null, model?: string | null, active?: boolean | null } | null } | null, previousAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, reminderIsSent?: boolean | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null } | null> | null, suggestedAppointments?: Array<{ __typename?: 'Appointment', id?: string | null, fitterId?: string | null, brandId?: string | null, time?: any | null, timezone?: string | null, immobilisationDuration?: number | null, interventionDuration?: number | null, isInterventionDifficult?: boolean | null, totalCost?: number | null, extraCost?: number | null, outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, isReplacementVehicleSelected?: boolean | null, status?: string | null, isConveying?: boolean | null, interventionId?: string | null, interventionLocation?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null } | null> | null, gpdr?: { __typename?: 'GpdrData', accepted?: boolean | null, time?: any | null } | null, marketingData?: { __typename?: 'MarketingData', accepted?: boolean | null, time?: any | null } | null, call?: Array<{ __typename?: 'Call', callSid?: string | null, status?: string | null, creationDate?: any | null, callDuration?: number | null, phoneNumberTo?: string | null, phoneNumberFrom?: string | null, userCaller?: string | null, userCallee?: string | null, callReason?: string | null, conferenceName?: string | null } | null> | null, searchCriteria?: { __typename?: 'DossierSearchLocation', address?: { __typename?: 'LocationDataGeocoded', isKnownAddress?: boolean | null, locationProvider?: string | null, placeId?: string | null, address?: string | null, isCompleteAddress?: boolean | null, timezone?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', lat?: number | null, lon?: number | null } | null, addressElements?: { __typename?: 'AddressElements', streetNumber?: string | null, streetName?: string | null, streetSuffix?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null, countryCode?: string | null } | null } | null, filters?: { __typename?: 'SearchFilters', groupBy?: string | null, period?: { __typename?: 'TimeFilters', start?: number | null, end?: number | null } | null, interventionParams?: { __typename?: 'InterventionParams', outsideIntervention?: boolean | null, replacementVehicle?: boolean | null, fitterIntervention?: boolean | null, displayGeneralists?: boolean | null, displayGlassSpecialist?: boolean | null } | null } | null } | null, externalReferences?: { __typename?: 'DossierExternalReferences', horizonsId?: string | null, damageId?: string | null } | null, dossierComments?: Array<{ __typename?: 'DossierComments', userName: string, timestamp: any, comment: string, commentType: string, isPinned?: boolean | null } | null> | null } | null };

export type FitterQueryVariables = Exact<{
  id: Scalars['String']['input'];
  brandId: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
}>;


export type FitterQuery = { __typename?: 'Query', fitter?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, timezone?: string | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, google?: { __typename?: 'FitterGoogleData', name?: string | null, place_id?: string | null, rating?: number | null, formatted_address?: string | null, business_status?: string | null, website?: string | null, user_ratings_total?: number | null, review?: Array<any | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null } | null };

export type FittersQueryVariables = Exact<{
  distance: Scalars['Int']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  shouldWidenSearch?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAgendaFitters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FittersQuery = { __typename?: 'Query', fitters?: Array<{ __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, timezone?: string | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, google?: { __typename?: 'FitterGoogleData', name?: string | null, place_id?: string | null, rating?: number | null, formatted_address?: string | null, business_status?: string | null, website?: string | null, user_ratings_total?: number | null, review?: Array<any | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null } | null> | null };

export type SearchFittersQueryVariables = Exact<{
  filters?: InputMaybe<FitterSearchInput>;
}>;


export type SearchFittersQuery = { __typename?: 'Query', searchFitters?: Array<{ __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, timezone?: string | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, google?: { __typename?: 'FitterGoogleData', name?: string | null, place_id?: string | null, rating?: number | null, formatted_address?: string | null, business_status?: string | null, website?: string | null, user_ratings_total?: number | null, review?: Array<any | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null } | null> | null };

export type SearchMasterFittersQueryVariables = Exact<{
  filters?: InputMaybe<FitterMasterSearchInput>;
}>;


export type SearchMasterFittersQuery = { __typename?: 'Query', searchMasterFitters?: Array<{ __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, timezone?: string | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, google?: { __typename?: 'FitterGoogleData', name?: string | null, place_id?: string | null, rating?: number | null, formatted_address?: string | null, business_status?: string | null, website?: string | null, user_ratings_total?: number | null, review?: Array<any | null> | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null } | null> | null };

export type FitterStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type FitterStatisticsQuery = { __typename?: 'Query', fitterStatistics?: Array<{ __typename?: 'FitterStatistic', id?: string | null, brandId?: string | null, periodType?: string | null, period?: string | null, insuranceStat?: any | null } | null> | null };

export type CreateFitterMutationVariables = Exact<{
  fitter: FitterBaseInput;
}>;


export type CreateFitterMutation = { __typename?: 'Mutation', createFitter?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null } | null };

export type UpdateFitterMutationVariables = Exact<{
  fitter: FitterInput;
}>;


export type UpdateFitterMutation = { __typename?: 'Mutation', updateFitter?: { __typename?: 'Fitter', id: string, fceId?: string | null, internalId?: string | null, siret?: string | null, brand?: string | null, brandId?: string | null, fitterType?: string | null, city?: string | null, address?: string | null, cp?: string | null, phone?: string | null, distance?: number | null, brandLogo?: string | null, email?: string | null, location?: { __typename?: 'GeoCoordinatesFitter', lat?: number | null, lon?: number | null } | null, openingHours?: { __typename?: 'FitterOpeningHours', center?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, outside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webCenter?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null, webOutside?: Array<{ __typename?: 'FitterOpeningPeriod', open?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null, close?: { __typename?: 'FitterOpeningLimit', day?: number | null, time?: string | null, allDay?: boolean | null } | null } | null> | null } | null } | null };

export type DeleteFitterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['String']['input'];
}>;


export type DeleteFitterMutation = { __typename?: 'Mutation', deleteFitter?: boolean | null };

export type MyEventSubscriptionVariables = Exact<{
  clientKey: Scalars['String']['input'];
}>;


export type MyEventSubscription = { __typename?: 'Subscription', myEvent: { __typename?: 'Event', clientKey: string, timestamp: string, echoResponse?: { __typename?: 'EchoResponse', message?: string | null } | null, freeSlotsResults?: { __typename?: 'FreeSlotsResult', appointments?: any | null, fitter?: any | null, globalScores?: any | null, status?: any | null, dotFitters?: any | null } | null, newDossier?: { __typename?: 'NewDossier', dossierId?: string | null } | null, updatedDossier?: { __typename?: 'UpdatedDossier', dossierId?: string | null, updateType?: Array<string | null> | null } | null, departingDossier?: { __typename?: 'DepartingDossier', dossierId?: string | null, oldFitterId?: string | null, newFitterId?: string | null } | null, openDossier?: { __typename?: 'OpenDossier', dossierId?: string | null } | null, closeDossier?: { __typename?: 'CloseDossier', dossierId?: string | null } | null, errors?: Array<{ __typename?: 'Error', name?: string | null, message?: string | null, code?: string | null, status?: number | null, severity?: string | null } | null> | null } };

export type RegisterPollingQueryVariables = Exact<{
  clientKey: Scalars['String']['input'];
}>;


export type RegisterPollingQuery = { __typename?: 'Query', registerPolling?: { __typename?: 'Ack', clientKey?: string | null, timestamp?: string | null } | null };

export type UnregisterKeyMutationVariables = Exact<{
  clientKey: Scalars['String']['input'];
}>;


export type UnregisterKeyMutation = { __typename?: 'Mutation', unregisterKey?: { __typename?: 'Ack', clientKey?: string | null, timestamp?: string | null } | null };

export type EchoQueryVariables = Exact<{
  clientKey: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type EchoQuery = { __typename?: 'Query', echo?: { __typename?: 'Ack', clientKey?: string | null, timestamp?: string | null } | null };

export type PollMutationVariables = Exact<{
  clientKey: Scalars['String']['input'];
}>;


export type PollMutation = { __typename?: 'Mutation', poll?: { __typename?: 'Event', clientKey: string, timestamp: string, echoResponse?: { __typename?: 'EchoResponse', message?: string | null } | null, freeSlotsResults?: { __typename?: 'FreeSlotsResult', appointments?: any | null, fitter?: any | null, globalScores?: any | null, status?: any | null, dotFitters?: any | null } | null, newDossier?: { __typename?: 'NewDossier', dossierId?: string | null } | null, updatedDossier?: { __typename?: 'UpdatedDossier', dossierId?: string | null, updateType?: Array<string | null> | null } | null, departingDossier?: { __typename?: 'DepartingDossier', dossierId?: string | null, oldFitterId?: string | null, newFitterId?: string | null } | null, openDossier?: { __typename?: 'OpenDossier', dossierId?: string | null } | null, closeDossier?: { __typename?: 'CloseDossier', dossierId?: string | null } | null, errors?: Array<{ __typename?: 'Error', name?: string | null, message?: string | null, code?: string | null, status?: number | null, severity?: string | null } | null> | null } | null };

export const EventDocument = gql`
    query event($id: ID!) {
  event(id: $id) {
    id
    brandId
    fitterId
    comment
    type
    title
    startTime
    endTime
    timezone
    resources {
      name
    }
    creationData {
      code
      email
      origin
    }
    createDate
    updateDate
    allDay
    locations
    additionalData
    recurrent {
      startDate
      endDate
      freq
      every
      daysOfWeek
      daysDeletes {
        startDate
        endDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventGQL extends Apollo.Query<EventQuery, EventQueryVariables> {
    document = EventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventsDocument = gql`
    query events($fitterIds: [String], $eventType: String) {
  events(fitterIds: $fitterIds, eventType: $eventType) {
    id
    brandId
    fitterId
    comment
    type
    title
    startTime
    endTime
    timezone
    resources {
      name
    }
    creationData {
      code
      email
      origin
    }
    createDate
    updateDate
    allDay
    locations
    additionalData
    recurrent {
      startDate
      endDate
      freq
      every
      daysOfWeek
      daysDeletes {
        startDate
        endDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventsGQL extends Apollo.Query<EventsQuery, EventsQueryVariables> {
    document = EventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEventDocument = gql`
    mutation createEvent($event: AgendaEventInput!) {
  createEvent(event: $event) {
    brandId
    fitterId
    comment
    type
    title
    startTime
    endTime
    timezone
    allDay
    resources {
      name
    }
    locations
    additionalData
    recurrent {
      startDate
      endDate
      freq
      every
      daysOfWeek
      daysDeletes {
        startDate
        endDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEventGQL extends Apollo.Mutation<CreateEventMutation, CreateEventMutationVariables> {
    document = CreateEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkCreateEventDocument = gql`
    mutation bulkCreateEvent($events: [AgendaEventInput]!) {
  bulkCreateEvent(events: $events) {
    brandId
    fitterId
    comment
    type
    title
    startTime
    endTime
    timezone
    allDay
    resources {
      name
    }
    locations
    additionalData
    recurrent {
      startDate
      endDate
      freq
      every
      daysOfWeek
      daysDeletes {
        startDate
        endDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkCreateEventGQL extends Apollo.Mutation<BulkCreateEventMutation, BulkCreateEventMutationVariables> {
    document = BulkCreateEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventDocument = gql`
    mutation updateEvent($event: AgendaEventInput!) {
  updateEvent(event: $event) {
    id
    brandId
    fitterId
    comment
    type
    title
    startTime
    endTime
    timezone
    allDay
    resources {
      name
    }
    locations
    additionalData
    recurrent {
      startDate
      endDate
      freq
      every
      daysOfWeek
      daysDeletes {
        startDate
        endDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEventGQL extends Apollo.Mutation<UpdateEventMutation, UpdateEventMutationVariables> {
    document = UpdateEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventDocument = gql`
    mutation deleteEvent($id: ID!) {
  deleteEvent(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEventGQL extends Apollo.Mutation<DeleteEventMutation, DeleteEventMutationVariables> {
    document = DeleteEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFittersByManagerDocument = gql`
    query getFittersByManager {
  getFittersByManager {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    distance
    brandLogo
    email
    timezone
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
    vehicles {
      id
      name
      licensePlateNumber
      manufacturer
      model
      active
    }
    serviceTypes {
      id
      name
      glassType
      operationType
      interventionDuration
      interventionDurationMobility
      canBookOnline
      canMakeInCenterIntervention
      canMakeOutsideIntervention
      canShareReplacementVehicle
      color
      active
      default
      offSet
      mobilityOffSet
      weekendOffset {
        isActive
        offSet
        startDay
        startHour
        endDay
        endHour
      }
      calibration
      slotAvailability {
        mode
        cutOffs {
          morning
          afternoon
        }
      }
    }
    managers {
      email
      fitterComment
      lastName
      firstName
      accessTypes
    }
    contactList {
      name
      email
      activeEmail
      phone {
        number
        internationalCode
        countryCode
      }
      activePhone
    }
    resources {
      active
      name
    }
    interventionVehicles {
      active
      name
    }
    maxParallelJob
    maxMobilityParallelJob
    useTechAvailabilityForOutisdeIntervention
    filterLabels {
      technicianLabel
      interventionVehicleLabel
      replacementVehicleLabel
    }
    google {
      place_id
    }
    mobilityZones
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFittersByManagerGQL extends Apollo.Query<GetFittersByManagerQuery, GetFittersByManagerQueryVariables> {
    document = GetFittersByManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFitterByManagerDocument = gql`
    query getFitterByManager($id: String!) {
  getFitterByManager(id: $id) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    google {
      place_id
    }
    distance
    brandLogo
    email
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
    vehicles {
      id
      name
      licensePlateNumber
      manufacturer
      model
      active
    }
    serviceTypes {
      id
      name
      glassType
      operationType
      interventionDuration
      interventionDurationMobility
      canBookOnline
      canMakeInCenterIntervention
      canMakeOutsideIntervention
      canShareReplacementVehicle
      color
      active
      default
      offSet
      mobilityOffSet
      weekendOffset {
        isActive
        offSet
        startDay
        startHour
        endDay
        endHour
      }
      calibration
      slotAvailability {
        mode
        cutOffs {
          morning
          afternoon
        }
      }
    }
    managers {
      email
      fitterComment
      lastName
      firstName
      accessTypes
    }
    contactList {
      name
      email
      activeEmail
      phone {
        number
        internationalCode
        countryCode
      }
      activePhone
    }
    resources {
      active
      name
    }
    interventionVehicles {
      active
      name
    }
    maxParallelJob
    maxMobilityParallelJob
    useTechAvailabilityForOutisdeIntervention
    filterLabels {
      technicianLabel
      interventionVehicleLabel
      replacementVehicleLabel
    }
    google {
      place_id
    }
    mobilityZones
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFitterByManagerGQL extends Apollo.Query<GetFitterByManagerQuery, GetFitterByManagerQueryVariables> {
    document = GetFitterByManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllFittersByIdDocument = gql`
    query getAllFittersById($ids: [String!]!) {
  getAllFittersById(ids: $ids) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    distance
    brandLogo
    email
    timezone
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
    vehicles {
      id
      name
      licensePlateNumber
      manufacturer
      model
      active
    }
    serviceTypes {
      id
      name
      glassType
      operationType
      interventionDuration
      interventionDurationMobility
      canBookOnline
      canMakeInCenterIntervention
      canMakeOutsideIntervention
      canShareReplacementVehicle
      color
      active
      default
      offSet
      mobilityOffSet
      weekendOffset {
        isActive
        offSet
        startDay
        startHour
        endDay
        endHour
      }
      calibration
      slotAvailability {
        mode
        cutOffs {
          morning
          afternoon
        }
      }
    }
    managers {
      email
      fitterComment
      lastName
      firstName
      accessTypes
    }
    contactList {
      name
      email
      activeEmail
      phone {
        number
        internationalCode
        countryCode
      }
      activePhone
    }
    resources {
      active
      name
    }
    interventionVehicles {
      active
      name
    }
    maxParallelJob
    maxMobilityParallelJob
    useTechAvailabilityForOutisdeIntervention
    filterLabels {
      technicianLabel
      interventionVehicleLabel
      replacementVehicleLabel
    }
    google {
      place_id
    }
    mobilityZones
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllFittersByIdGQL extends Apollo.Query<GetAllFittersByIdQuery, GetAllFittersByIdQueryVariables> {
    document = GetAllFittersByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCoveredCitiesDocument = gql`
    query getCoveredCities($fitterId: String!) {
  getCoveredCities(id: $fitterId) {
    postalCode
    cities
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCoveredCitiesGQL extends Apollo.Query<GetCoveredCitiesQuery, GetCoveredCitiesQueryVariables> {
    document = GetCoveredCitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAgendaFitterDocument = gql`
    mutation updateAgendaFitter($fitter: FitterInput!) {
  updateFitter(fitter: $fitter) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    distance
    brandLogo
    email
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
    vehicles {
      id
      name
      licensePlateNumber
      manufacturer
      model
      active
    }
    serviceTypes {
      id
      name
      glassType
      operationType
      interventionDuration
      interventionDurationMobility
      canBookOnline
      canMakeInCenterIntervention
      canMakeOutsideIntervention
      canShareReplacementVehicle
      color
      active
      default
      offSet
      weekendOffset {
        isActive
        offSet
        startDay
        startHour
        endDay
        endHour
      }
      calibration
      slotAvailability {
        mode
        cutOffs {
          morning
          afternoon
        }
      }
    }
    managers {
      email
      fitterComment
      lastName
      firstName
      accessTypes
    }
    contactList {
      name
      email
      activeEmail
      phone {
        number
        internationalCode
        countryCode
      }
      activePhone
    }
    resources {
      active
      name
    }
    interventionVehicles {
      active
      name
    }
    maxParallelJob
    maxMobilityParallelJob
    useTechAvailabilityForOutisdeIntervention
    filterLabels {
      technicianLabel
      interventionVehicleLabel
      replacementVehicleLabel
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAgendaFitterGQL extends Apollo.Mutation<UpdateAgendaFitterMutation, UpdateAgendaFitterMutationVariables> {
    document = UpdateAgendaFitterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFitterCommentDocument = gql`
    mutation updateFitterComment($id: ID!, $comment: String!) {
  updateFitterComment(id: $id, comment: $comment) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    google {
      name
      place_id
      rating
      formatted_address
      business_status
      website
      user_ratings_total
      review
      location {
        lat
        lon
      }
    }
    distance
    brandLogo
    email
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
    vehicles {
      id
      name
      licensePlateNumber
      manufacturer
      model
      active
    }
    serviceTypes {
      id
      name
      glassType
      operationType
      interventionDuration
      interventionDurationMobility
      canBookOnline
      canMakeInCenterIntervention
      canMakeOutsideIntervention
      canShareReplacementVehicle
      color
      active
      default
      offSet
      weekendOffset {
        isActive
        offSet
        startDay
        startHour
        endDay
        endHour
      }
      calibration
      slotAvailability {
        mode
        cutOffs {
          morning
          afternoon
        }
      }
    }
    managers {
      email
      fitterComment
      lastName
      firstName
      accessTypes
    }
    contactList {
      name
      email
      activeEmail
      phone {
        number
        internationalCode
        countryCode
      }
      activePhone
    }
    resources {
      active
      name
    }
    interventionVehicles {
      active
      name
    }
    maxParallelJob
    maxMobilityParallelJob
    useTechAvailabilityForOutisdeIntervention
    filterLabels {
      technicianLabel
      interventionVehicleLabel
      replacementVehicleLabel
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFitterCommentGQL extends Apollo.Mutation<UpdateFitterCommentMutation, UpdateFitterCommentMutationVariables> {
    document = UpdateFitterCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAgendaFitterDocument = gql`
    mutation createAgendaFitter($fitter: FitterBaseInput!) {
  createFitter(fitter: $fitter) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    distance
    brandLogo
    email
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
    vehicles {
      id
      name
      licensePlateNumber
      manufacturer
      model
      active
    }
    serviceTypes {
      id
      name
      glassType
      operationType
      interventionDuration
      interventionDurationMobility
      canBookOnline
      canMakeInCenterIntervention
      canMakeOutsideIntervention
      canShareReplacementVehicle
      color
      active
      default
      offSet
      weekendOffset {
        isActive
        offSet
        startDay
        startHour
        endDay
        endHour
      }
      calibration
      slotAvailability {
        mode
        cutOffs {
          morning
          afternoon
        }
      }
    }
    managers {
      email
      fitterComment
      lastName
      firstName
      accessTypes
    }
    contactList {
      name
      email
      activeEmail
      phone {
        number
        internationalCode
        countryCode
      }
      activePhone
    }
    resources {
      active
      name
    }
    interventionVehicles {
      active
      name
    }
    maxParallelJob
    maxMobilityParallelJob
    useTechAvailabilityForOutisdeIntervention
    filterLabels {
      technicianLabel
      interventionVehicleLabel
      replacementVehicleLabel
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAgendaFitterGQL extends Apollo.Mutation<CreateAgendaFitterMutation, CreateAgendaFitterMutationVariables> {
    document = CreateAgendaFitterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkUpdateOpeningHoursWebInCenterDocument = gql`
    mutation bulkUpdateOpeningHoursWebInCenter($fittersOpeningHours: [FitterOpeningHoursInput]!) {
  bulkUpdateOpeningHoursWebInCenter(fittersOpeningHours: $fittersOpeningHours)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkUpdateOpeningHoursWebInCenterGQL extends Apollo.Mutation<BulkUpdateOpeningHoursWebInCenterMutation, BulkUpdateOpeningHoursWebInCenterMutationVariables> {
    document = BulkUpdateOpeningHoursWebInCenterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkUpdateOpeningHoursWebOutsideInterventionDocument = gql`
    mutation bulkUpdateOpeningHoursWebOutsideIntervention($fittersOpeningHours: [FitterOpeningHoursInput]!) {
  bulkUpdateOpeningHoursWebOutsideIntervention(
    fittersOpeningHours: $fittersOpeningHours
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkUpdateOpeningHoursWebOutsideInterventionGQL extends Apollo.Mutation<BulkUpdateOpeningHoursWebOutsideInterventionMutation, BulkUpdateOpeningHoursWebOutsideInterventionMutationVariables> {
    document = BulkUpdateOpeningHoursWebOutsideInterventionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DossierDocument = gql`
    query dossier($id: ID!) {
  dossier(id: $id) {
    id
    selectedLanguage
    creationData {
      code
      email
      origin
      businessOrigin
    }
    state
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    claim {
      sinisterDate
      sinisterPlace {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      car {
        registrationCode
        countryCode
        licensePlateNumber
        manufacturer
        version
        model
        firstRegistration
        parts
        vinNumber
        ownerShip {
          type
          name
        }
        characteristics {
          registration
          registrationType
          color
          energy
          cylinders
          numberOfDoors
          propulsionType
          chassisNumber
          modelYear
          engineNumber
          gearboxType
          gearboxNbSpeed
          gearboxNumber
          unloadedWeight
          horsepower
          fiscalPower
          kwPower
          totalRollingWeight
          co2Emission
        }
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      operationType
      sinisterComment
      sinisterLocation
      sinisterContext {
        key
        value
      }
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
      email
      location {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      billingLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      phoneNumber {
        number
        internationalCode
        countryCode
      }
      birthDate
    }
    insurer {
      code
    }
    fitterInfo {
      message
      isReadyToBill
    }
    insurerData {
      dossierId
      callAgent
      callAgentFirstname
      callAgentLastname
      comment
      other
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    policyInformation {
      insuranceChoice
      insuranceName
      insuranceCode
      policyNumber
      vatNumber
      insuredFirstname
      insuredLastname
      insuredEmail
      insuredPhoneNumber
      insuranceStartDate
      insuranceEndDate
      isGuaranteeConditionRetrieveWithSuccess
      isCancelled
      isCancelledWithoutPayment
      isSuspended
      isCovered
      coverBDG
      excessTakeover
      replacementDeductible
      repairDeductible
      replacementRateDeductible
      repairRateDeductible
      minReplacementDeductible
      maxReplacementDeductible
      minRepairDeductible
      maxRepairDeductible
      replacementGuaranteeCeiling
      repairGuaranteeCeiling
      sinisterNumber
    }
    appointment {
      id
      fitterId
      brandId
      time
      endTime
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      partProvider
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    previousAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    suggestedAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    createDate
    updateDate
    gpdr {
      accepted
      time
    }
    marketingData {
      accepted
      time
    }
    call {
      callSid
      status
      creationDate
      callDuration
      phoneNumberTo
      phoneNumberFrom
      userCaller
      userCallee
      callReason
      conferenceName
    }
    searchCriteria {
      address {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      filters {
        groupBy
        period {
          start
          end
        }
        interventionParams {
          outsideIntervention
          replacementVehicle
          fitterIntervention
          displayGeneralists
          displayGlassSpecialist
        }
      }
    }
    externalId
    canNotifyCustomer
    declarationPage
    externalReferences {
      horizonsId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
    nps {
      score
      comment
      userSkipped
      appOrigin
      timestamp
    }
    abTesting {
      abTestType
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DossierGQL extends Apollo.Query<DossierQuery, DossierQueryVariables> {
    document = DossierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DossierBySinisterNumberDocument = gql`
    query dossierBySinisterNumber($sinisterNumber: String!) {
  dossierBySinisterNumber(sinisterNumber: $sinisterNumber) {
    id
    selectedLanguage
    creationData {
      code
      email
      origin
      businessOrigin
    }
    state
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    claim {
      sinisterDate
      sinisterPlace {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      car {
        registrationCode
        countryCode
        licensePlateNumber
        manufacturer
        version
        model
        firstRegistration
        parts
        vinNumber
        ownerShip {
          type
          name
        }
        characteristics {
          registration
          registrationType
          color
          energy
          cylinders
          numberOfDoors
          propulsionType
          chassisNumber
          modelYear
          engineNumber
          gearboxType
          gearboxNbSpeed
          gearboxNumber
          unloadedWeight
          horsepower
          fiscalPower
          kwPower
          totalRollingWeight
          co2Emission
        }
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
        }
      }
      operationType
      sinisterComment
      sinisterLocation
      sinisterContext {
        key
        value
      }
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
      email
      location {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      billingLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      phoneNumber {
        number
        internationalCode
        countryCode
      }
      birthDate
    }
    insurer {
      code
    }
    fitterInfo {
      message
      isReadyToBill
    }
    insurerData {
      dossierId
      callAgent
      callAgentFirstname
      callAgentLastname
      comment
      other
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    policyInformation {
      insuranceChoice
      insuranceName
      insuranceCode
      policyNumber
      vatNumber
      insuredFirstname
      insuredLastname
      insuredEmail
      insuredPhoneNumber
      insuranceStartDate
      insuranceEndDate
      isGuaranteeConditionRetrieveWithSuccess
      isCancelled
      isCancelledWithoutPayment
      isSuspended
      isCovered
      coverBDG
      excessTakeover
      replacementDeductible
      repairDeductible
      replacementRateDeductible
      repairRateDeductible
      minReplacementDeductible
      maxReplacementDeductible
      minRepairDeductible
      maxRepairDeductible
      replacementGuaranteeCeiling
      repairGuaranteeCeiling
      sinisterNumber
    }
    appointment {
      id
      fitterId
      brandId
      time
      endTime
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      partProvider
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    previousAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    suggestedAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    createDate
    updateDate
    gpdr {
      accepted
      time
    }
    marketingData {
      accepted
      time
    }
    call {
      callSid
      status
      creationDate
      callDuration
      phoneNumberTo
      phoneNumberFrom
      userCaller
      userCallee
      callReason
      conferenceName
    }
    searchCriteria {
      address {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      filters {
        groupBy
        period {
          start
          end
        }
        interventionParams {
          outsideIntervention
          replacementVehicle
          fitterIntervention
          displayGeneralists
          displayGlassSpecialist
        }
      }
    }
    externalId
    canNotifyCustomer
    declarationPage
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
    nps {
      score
      comment
      userSkipped
      appOrigin
      timestamp
    }
    abTesting {
      abTestType
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DossierBySinisterNumberGQL extends Apollo.Query<DossierBySinisterNumberQuery, DossierBySinisterNumberQueryVariables> {
    document = DossierBySinisterNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDossiersDocument = gql`
    query searchDossiers($searchText: String, $status: [String], $creationDates: SearchDatesInput, $fitters: [SearchFittersInput], $advancedFilters: DossierAdvancedFiltersInput) {
  searchDossiers(
    searchText: $searchText
    status: $status
    creationDates: $creationDates
    fitters: $fitters
    advancedFilters: $advancedFilters
    limit: 100
  ) {
    id
    state
    claim {
      sinisterDate
      sinisterPlace {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      car {
        licensePlateNumber
        manufacturer
        version
        model
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      operationType
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurer {
      code
    }
    fitterInfo {
      message
      isReadyToBill
    }
    insurerData {
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    marketingData {
      accepted
      time
    }
    appointment {
      id
      fitterId
      brandId
      time
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      outsideIntervention
      status
      comment
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      outsideIntervention
      isReplacementVehicleSelected
      status
      comment
      isConveying
      interventionId
      isValidatedByFitter
      itinerary {
        duration
        distance
      }
    }
    searchCriteria {
      address {
        address
      }
    }
    creationData {
      code
      email
      origin
      businessOrigin
    }
    createDate
    updateDate
    declarationPage
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
    nps {
      score
      comment
      userSkipped
      appOrigin
      timestamp
    }
    abTesting {
      abTestType
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDossiersGQL extends Apollo.Query<SearchDossiersQuery, SearchDossiersQueryVariables> {
    document = SearchDossiersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDossiersAgendaDocument = gql`
    query searchDossiersAgenda($fitterIds: [String], $status: [String], $filters: DossierAgendaFiltersInput, $limit: Int) {
  searchDossiersAgenda(
    fitterIds: $fitterIds
    status: $status
    filters: $filters
    limit: $limit
  ) {
    id
    state
    claim {
      sinisterDate
      sinisterPlace {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      car {
        licensePlateNumber
        manufacturer
        version
        model
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      operationType
      sinisterLocation
      sinisterContext {
        key
        value
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
      phoneNumber {
        number
      }
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurer {
      code
    }
    insurerData {
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    fitterInfo {
      message
      isReadyToBill
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      endTime
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      outsideIntervention
      status
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      isReplacementVehicleSelected
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      partProvider
      comment
      isConveying
      interventionId
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
    }
    createDate
    updateDate
    creationData {
      code
      email
      origin
      businessOrigin
    }
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDossiersAgendaGQL extends Apollo.Query<SearchDossiersAgendaQuery, SearchDossiersAgendaQueryVariables> {
    document = SearchDossiersAgendaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDossiersAgendaOverlapDocument = gql`
    query searchDossiersAgendaOverlap($fitterIds: [String!]!, $filters: DossierAgendaOverlapFiltersInput!) {
  searchDossiersAgendaOverlap(fitterIds: $fitterIds, filters: $filters) {
    id
    state
    claim {
      sinisterComment
      sinisterDate
      sinisterPlace {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      car {
        licensePlateNumber
        manufacturer
        version
        model
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      operationType
      sinisterLocation
      sinisterContext {
        key
        value
      }
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
      email
      phoneNumber {
        number
      }
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurer {
      code
    }
    insurerData {
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    fitterInfo {
      message
      isReadyToBill
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      endTime
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      outsideIntervention
      status
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      isReplacementVehicleSelected
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      partProvider
      comment
      isConveying
      interventionId
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
    }
    createDate
    updateDate
    creationData {
      code
      email
      origin
      businessOrigin
    }
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDossiersAgendaOverlapGQL extends Apollo.Query<SearchDossiersAgendaOverlapQuery, SearchDossiersAgendaOverlapQueryVariables> {
    document = SearchDossiersAgendaOverlapDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDossiersToValidateAgendaDocument = gql`
    query searchDossiersToValidateAgenda($fitterIds: [String!]!) {
  searchDossiersToValidateAgenda(fitterIds: $fitterIds) {
    id
    state
    claim {
      sinisterComment
      sinisterDate
      sinisterPlace {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      car {
        licensePlateNumber
        manufacturer
        version
        model
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      operationType
      sinisterLocation
      sinisterContext {
        key
        value
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
      email
      phoneNumber {
        number
      }
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurer {
      code
    }
    insurerData {
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    fitterInfo {
      message
      isReadyToBill
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      endTime
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      outsideIntervention
      status
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      isReplacementVehicleSelected
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      partProvider
      comment
      isConveying
      interventionId
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
    }
    createDate
    updateDate
    creationData {
      code
      email
      origin
      businessOrigin
    }
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDossiersToValidateAgendaGQL extends Apollo.Query<SearchDossiersToValidateAgendaQuery, SearchDossiersToValidateAgendaQueryVariables> {
    document = SearchDossiersToValidateAgendaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDossiersRequestedApmtAgendaDocument = gql`
    query searchDossiersRequestedApmtAgenda($fitterIds: [String], $limit: Int) {
  searchDossiersRequestedApmtAgenda(fitterIds: $fitterIds, limit: $limit) {
    id
    state
    claim {
      sinisterComment
      sinisterDate
      sinisterPlace {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      car {
        licensePlateNumber
        manufacturer
        version
        model
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      operationType
      sinisterLocation
      sinisterContext {
        key
        value
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      calibration
      eurocode
      constructorRef
    }
    customer {
      firstname
      lastname
      email
      phoneNumber {
        number
      }
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurer {
      code
    }
    insurerData {
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    fitterInfo {
      message
      isReadyToBill
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      endTime
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      outsideIntervention
      status
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      isReplacementVehicleSelected
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      partProvider
      comment
      isConveying
      interventionId
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        address
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
    }
    createDate
    updateDate
    creationData {
      code
      email
      origin
      businessOrigin
    }
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDossiersRequestedApmtAgendaGQL extends Apollo.Query<SearchDossiersRequestedApmtAgendaQuery, SearchDossiersRequestedApmtAgendaQueryVariables> {
    document = SearchDossiersRequestedApmtAgendaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDossierByCustomerNameDocument = gql`
    query searchDossierByCustomerName($customerName: String, $brandId: String, $fitterId: String) {
  searchDossierByCustomerName(
    customerName: $customerName
    brandId: $brandId
    fitterId: $fitterId
  ) {
    id
    customerName
    customerFirstName
    licensePlateNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDossierByCustomerNameGQL extends Apollo.Query<SearchDossierByCustomerNameQuery, SearchDossierByCustomerNameQueryVariables> {
    document = SearchDossierByCustomerNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDossierDocument = gql`
    mutation updateDossier($dossier: DossierInput!) {
  updateDossier(dossier: $dossier) {
    id
    selectedLanguage
    creationData {
      code
      email
      origin
      businessOrigin
    }
    stateHistory {
      userType
      state
      timestamp
      data
      userName
    }
    state
    claim {
      sinisterComment
      sinisterDate
      sinisterPlace {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      car {
        registrationCode
        licensePlateNumber
        countryCode
        manufacturer
        version
        model
        firstRegistration
        parts
        vinNumber
        ownerShip {
          type
          name
        }
        characteristics {
          registration
          registrationType
          color
          energy
          cylinders
          numberOfDoors
          propulsionType
          chassisNumber
          modelYear
          engineNumber
          gearboxType
          gearboxNbSpeed
          gearboxNumber
          unloadedWeight
          horsepower
          fiscalPower
          kwPower
          totalRollingWeight
          co2Emission
        }
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      operationType
      calibration
      eurocode
      constructorRef
    }
    fitterInfo {
      message
      isReadyToBill
    }
    customer {
      firstname
      lastname
      email
      location {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      billingLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      phoneNumber {
        number
        internationalCode
        countryCode
      }
      birthDate
    }
    insurer {
      code
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurerData {
      dossierId
      callAgent
      callAgentFirstname
      callAgentLastname
      comment
      other
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    policyInformation {
      insuranceChoice
      insuranceName
      insuranceCode
      policyNumber
      vatNumber
      insuredFirstname
      insuredLastname
      insuredEmail
      insuredPhoneNumber
      insuranceStartDate
      insuranceEndDate
      isGuaranteeConditionRetrieveWithSuccess
      isCancelled
      isCancelledWithoutPayment
      isSuspended
      isCovered
      coverBDG
      excessTakeover
      replacementDeductible
      repairDeductible
      replacementRateDeductible
      repairRateDeductible
      minReplacementDeductible
      maxReplacementDeductible
      minRepairDeductible
      maxRepairDeductible
      replacementGuaranteeCeiling
      repairGuaranteeCeiling
      sinisterNumber
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      comment
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    previousAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    suggestedAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      isConveying
      interventionId
      itinerary {
        duration
        distance
      }
    }
    createDate
    updateDate
    gpdr {
      accepted
      time
    }
    marketingData {
      accepted
      time
    }
    call {
      callSid
      status
      creationDate
      callDuration
      phoneNumberTo
      phoneNumberFrom
      userCaller
      userCallee
      callReason
      conferenceName
    }
    searchCriteria {
      address {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      filters {
        groupBy
        period {
          start
          end
        }
        interventionParams {
          outsideIntervention
          replacementVehicle
          fitterIntervention
          displayGeneralists
          displayGlassSpecialist
        }
      }
    }
    canNotifyCustomer
    declarationPage
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
    nps {
      score
      comment
      userSkipped
      appOrigin
      timestamp
    }
    abTesting {
      abTestType
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDossierGQL extends Apollo.Mutation<UpdateDossierMutation, UpdateDossierMutationVariables> {
    document = UpdateDossierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveDraftDossierDocument = gql`
    mutation saveDraftDossier($dossier: DossierInput!) {
  saveDraftDossier(dossier: $dossier) {
    id
    selectedLanguage
    creationData {
      code
      email
      origin
      businessOrigin
    }
    state
    claim {
      sinisterComment
      sinisterDate
      sinisterPlace {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      car {
        registrationCode
        licensePlateNumber
        countryCode
        manufacturer
        version
        model
        firstRegistration
        parts
        vinNumber
        ownerShip {
          type
          name
        }
        characteristics {
          registration
          registrationType
          color
          energy
          cylinders
          numberOfDoors
          propulsionType
          chassisNumber
          modelYear
          engineNumber
          gearboxType
          gearboxNbSpeed
          gearboxNumber
          unloadedWeight
          horsepower
          fiscalPower
          kwPower
          totalRollingWeight
          co2Emission
        }
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      operationType
      calibration
      eurocode
      constructorRef
    }
    fitterInfo {
      message
      isReadyToBill
    }
    customer {
      firstname
      lastname
      email
      location {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      billingLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      phoneNumber {
        number
        internationalCode
        countryCode
      }
      birthDate
    }
    insurer {
      code
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurerData {
      dossierId
      callAgent
      callAgentFirstname
      callAgentLastname
      comment
      other
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    policyInformation {
      insuranceChoice
      insuranceName
      insuranceCode
      policyNumber
      vatNumber
      insuredFirstname
      insuredLastname
      insuredEmail
      insuredPhoneNumber
      isGuaranteeConditionRetrieveWithSuccess
      isCancelled
      isCancelledWithoutPayment
      isSuspended
      coverBDG
      excessTakeover
      sinisterNumber
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      status
      reminderIsSent
      comment
      isConveying
      interventionId
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
    }
    previousAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isConveying
      interventionId
    }
    suggestedAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      isConveying
      interventionId
    }
    createDate
    updateDate
    gpdr {
      accepted
      time
    }
    marketingData {
      accepted
      time
    }
    call {
      callSid
      status
      creationDate
      callDuration
      phoneNumberTo
      phoneNumberFrom
      userCaller
      userCallee
      callReason
      conferenceName
    }
    searchCriteria {
      address {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      filters {
        groupBy
        period {
          start
          end
        }
        interventionParams {
          outsideIntervention
          replacementVehicle
          fitterIntervention
          displayGeneralists
          displayGlassSpecialist
        }
      }
    }
    declarationPage
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveDraftDossierGQL extends Apollo.Mutation<SaveDraftDossierMutation, SaveDraftDossierMutationVariables> {
    document = SaveDraftDossierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeDossierLanguageDocument = gql`
    mutation changeDossierLanguage($id: ID!, $language: String) {
  changeDossierLanguage(id: $id, language: $language)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeDossierLanguageGQL extends Apollo.Mutation<ChangeDossierLanguageMutation, ChangeDossierLanguageMutationVariables> {
    document = ChangeDossierLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AbandonDossierDocument = gql`
    mutation abandonDossier($id: ID!, $abandonmentComment: String) {
  abandonDossier(id: $id, abandonmentComment: $abandonmentComment) {
    abandonned
    dossierForContractManager
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AbandonDossierGQL extends Apollo.Mutation<AbandonDossierMutation, AbandonDossierMutationVariables> {
    document = AbandonDossierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendDossierConcurencyActionDocument = gql`
    mutation sendDossierConcurencyAction($id: ID!, $concurencyAction: DossierAgendaConcurencyAction!) {
  dossierAgendaConcurency(id: $id, concurencyAction: $concurencyAction)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendDossierConcurencyActionGQL extends Apollo.Mutation<SendDossierConcurencyActionMutation, SendDossierConcurencyActionMutationVariables> {
    document = SendDossierConcurencyActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveChatCommentsDocument = gql`
    mutation saveChatComments($updateComments: UpdateDossierCommentsInput!) {
  saveChatComments(updateComments: $updateComments) {
    id
    selectedLanguage
    creationData {
      code
      email
      origin
      businessOrigin
    }
    state
    claim {
      sinisterComment
      sinisterDate
      sinisterPlace {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      car {
        registrationCode
        licensePlateNumber
        countryCode
        manufacturer
        version
        model
        firstRegistration
        parts
        vinNumber
        ownerShip {
          type
          name
        }
        characteristics {
          registration
          registrationType
          color
          energy
          cylinders
          numberOfDoors
          propulsionType
          chassisNumber
          modelYear
          engineNumber
          gearboxType
          gearboxNbSpeed
          gearboxNumber
          unloadedWeight
          horsepower
          fiscalPower
          kwPower
          totalRollingWeight
          co2Emission
        }
        vehicleType
      }
      glass {
        glass
        glassExtended
        impacts {
          size
          impactsType
          inVisionField
          atOuterEdge
        }
        lateralPrecisions {
          frontConductor
          precision
        }
        mirror
        light {
          lateral
          lightsEmplacement
        }
      }
      documents {
        type
        url
        name
        metadata {
          lastModifiedDate
          name
          mimeType
          horizons {
            dossierId
            reference
            damageId
            documentId
          }
        }
      }
      operationType
      calibration
      eurocode
      constructorRef
    }
    fitterInfo {
      message
      isReadyToBill
    }
    customer {
      firstname
      lastname
      email
      location {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      billingLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      phoneNumber {
        number
        internationalCode
        countryCode
      }
      birthDate
    }
    insurer {
      code
    }
    currentlyInUse {
      userId
      userName
      timestamp
    }
    insurerData {
      dossierId
      callAgent
      callAgentFirstname
      callAgentLastname
      comment
      other
      abandonmentComment
      finishLaterComment
      rriNumber
    }
    policyInformation {
      insuranceChoice
      insuranceName
      insuranceCode
      policyNumber
      vatNumber
      insuredFirstname
      insuredLastname
      insuredEmail
      insuredPhoneNumber
      isGuaranteeConditionRetrieveWithSuccess
      isCancelled
      isCancelledWithoutPayment
      isSuspended
      coverBDG
      excessTakeover
      sinisterNumber
    }
    appointment {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      assignedReplacementVehicleUse {
        start
        end
      }
      status
      reminderIsSent
      comment
      isConveying
      interventionId
    }
    requestAppointment {
      fitterId
      brandId
      timezone
      immobilisationDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isValidatedByFitter
      comment
      partAvailability
      assignedResources
      assignedInterventionVehicle
      assignedReplacementVehicle {
        id
        name
        licensePlateNumber
        manufacturer
        model
        active
      }
      partProvider
      isConveying
      interventionId
    }
    previousAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      reminderIsSent
      isConveying
      interventionId
    }
    suggestedAppointments {
      id
      fitterId
      brandId
      time
      timezone
      immobilisationDuration
      interventionDuration
      interventionLocation {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
      }
      isInterventionDifficult
      totalCost
      extraCost
      outsideIntervention
      replacementVehicle
      isReplacementVehicleSelected
      status
      isConveying
      interventionId
    }
    createDate
    updateDate
    gpdr {
      accepted
      time
    }
    marketingData {
      accepted
      time
    }
    call {
      callSid
      status
      creationDate
      callDuration
      phoneNumberTo
      phoneNumberFrom
      userCaller
      userCallee
      callReason
      conferenceName
    }
    searchCriteria {
      address {
        isKnownAddress
        locationProvider
        placeId
        address
        isCompleteAddress
        geoCoordinates {
          lat
          lon
        }
        addressElements {
          streetNumber
          streetName
          streetSuffix
          postalCode
          city
          state
          country
          countryCode
        }
        timezone
      }
      filters {
        groupBy
        period {
          start
          end
        }
        interventionParams {
          outsideIntervention
          replacementVehicle
          fitterIntervention
          displayGeneralists
          displayGlassSpecialist
        }
      }
    }
    declarationPage
    externalReferences {
      horizonsId
      damageId
    }
    dossierComments {
      userName
      timestamp
      comment
      commentType
      isPinned
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveChatCommentsGQL extends Apollo.Mutation<SaveChatCommentsMutation, SaveChatCommentsMutationVariables> {
    document = SaveChatCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FitterDocument = gql`
    query fitter($id: String!, $brandId: String!, $address: String, $lat: Float, $lon: Float) {
  fitter(id: $id, brandId: $brandId, address: $address, lat: $lat, lon: $lon) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    google {
      name
      place_id
      rating
      formatted_address
      business_status
      website
      user_ratings_total
      review
      location {
        lat
        lon
      }
    }
    distance
    brandLogo
    email
    timezone
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FitterGQL extends Apollo.Query<FitterQuery, FitterQueryVariables> {
    document = FitterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FittersDocument = gql`
    query fitters($distance: Int!, $address: String, $lat: Float, $lon: Float, $shouldWidenSearch: Boolean, $onlyAgendaFitters: Boolean) {
  fitters(
    distance: $distance
    address: $address
    lat: $lat
    lon: $lon
    shouldWidenSearch: $shouldWidenSearch
    onlyAgendaFitters: $onlyAgendaFitters
  ) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    google {
      name
      place_id
      rating
      formatted_address
      business_status
      website
      user_ratings_total
      review
      location {
        lat
        lon
      }
    }
    distance
    brandLogo
    email
    timezone
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FittersGQL extends Apollo.Query<FittersQuery, FittersQueryVariables> {
    document = FittersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchFittersDocument = gql`
    query searchFitters($filters: FitterSearchInput) {
  searchFitters(filters: $filters) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    google {
      name
      place_id
      rating
      formatted_address
      business_status
      website
      user_ratings_total
      review
      location {
        lat
        lon
      }
    }
    distance
    brandLogo
    email
    timezone
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchFittersGQL extends Apollo.Query<SearchFittersQuery, SearchFittersQueryVariables> {
    document = SearchFittersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMasterFittersDocument = gql`
    query searchMasterFitters($filters: FitterMasterSearchInput) {
  searchMasterFitters(filters: $filters) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    google {
      name
      place_id
      rating
      formatted_address
      business_status
      website
      user_ratings_total
      review
      location {
        lat
        lon
      }
    }
    distance
    brandLogo
    email
    timezone
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMasterFittersGQL extends Apollo.Query<SearchMasterFittersQuery, SearchMasterFittersQueryVariables> {
    document = SearchMasterFittersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FitterStatisticsDocument = gql`
    query fitterStatistics {
  fitterStatistics {
    id
    brandId
    periodType
    period
    insuranceStat
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FitterStatisticsGQL extends Apollo.Query<FitterStatisticsQuery, FitterStatisticsQueryVariables> {
    document = FitterStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFitterDocument = gql`
    mutation createFitter($fitter: FitterBaseInput!) {
  createFitter(fitter: $fitter) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    distance
    brandLogo
    email
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFitterGQL extends Apollo.Mutation<CreateFitterMutation, CreateFitterMutationVariables> {
    document = CreateFitterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFitterDocument = gql`
    mutation updateFitter($fitter: FitterInput!) {
  updateFitter(fitter: $fitter) {
    id
    fceId
    internalId
    siret
    brand
    brandId
    fitterType
    city
    address
    cp
    phone
    location {
      lat
      lon
    }
    distance
    brandLogo
    email
    openingHours {
      center {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      outside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webCenter {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
      webOutside {
        open {
          day
          time
          allDay
        }
        close {
          day
          time
          allDay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFitterGQL extends Apollo.Mutation<UpdateFitterMutation, UpdateFitterMutationVariables> {
    document = UpdateFitterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFitterDocument = gql`
    mutation deleteFitter($id: ID!, $brandId: String!) {
  deleteFitter(id: $id, brandId: $brandId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFitterGQL extends Apollo.Mutation<DeleteFitterMutation, DeleteFitterMutationVariables> {
    document = DeleteFitterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyEventDocument = gql`
    subscription myEvent($clientKey: String!) {
  myEvent(clientKey: $clientKey) {
    clientKey
    timestamp
    echoResponse {
      message
    }
    freeSlotsResults {
      appointments
      fitter
      globalScores
      status
      dotFitters
    }
    newDossier {
      dossierId
    }
    updatedDossier {
      dossierId
      updateType
    }
    departingDossier {
      dossierId
      oldFitterId
      newFitterId
    }
    openDossier {
      dossierId
    }
    closeDossier {
      dossierId
    }
    errors {
      name
      message
      code
      status
      severity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyEventGQL extends Apollo.Subscription<MyEventSubscription, MyEventSubscriptionVariables> {
    document = MyEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterPollingDocument = gql`
    query registerPolling($clientKey: String!) {
  registerPolling(clientKey: $clientKey) {
    clientKey
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterPollingGQL extends Apollo.Query<RegisterPollingQuery, RegisterPollingQueryVariables> {
    document = RegisterPollingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnregisterKeyDocument = gql`
    mutation unregisterKey($clientKey: String!) {
  unregisterKey(clientKey: $clientKey) {
    clientKey
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnregisterKeyGQL extends Apollo.Mutation<UnregisterKeyMutation, UnregisterKeyMutationVariables> {
    document = UnregisterKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EchoDocument = gql`
    query echo($clientKey: String!, $message: String!) {
  echo(clientKey: $clientKey, message: $message) {
    clientKey
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EchoGQL extends Apollo.Query<EchoQuery, EchoQueryVariables> {
    document = EchoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PollDocument = gql`
    mutation poll($clientKey: String!) {
  poll(clientKey: $clientKey) {
    clientKey
    timestamp
    echoResponse {
      message
    }
    freeSlotsResults {
      appointments
      fitter
      globalScores
      status
      dotFitters
    }
    newDossier {
      dossierId
    }
    updatedDossier {
      dossierId
      updateType
    }
    departingDossier {
      dossierId
      oldFitterId
      newFitterId
    }
    openDossier {
      dossierId
    }
    closeDossier {
      dossierId
    }
    errors {
      name
      message
      code
      status
      severity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PollGQL extends Apollo.Mutation<PollMutation, PollMutationVariables> {
    document = PollDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }